(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("rxjs/operators"), require("rxjs"), require("mlb-media-player"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "rxjs/operators", "rxjs", "mlb-media-player", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["player-controls"] = factory(require("react"), require("rxjs/operators"), require("rxjs"), require("mlb-media-player"), require("react-dom"));
	else
		root["MLBPlayerControls"] = factory(root["React"], root["rxjs"]["operators"], root["rxjs"], root["MediaPlayer"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__29__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 135);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(34)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(36);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(86);
var hoist_non_react_statics_1 = tslib_1.__importDefault(__webpack_require__(9));
function compose() {
    var wrappingFunctions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        wrappingFunctions[_i] = arguments[_i];
    }
    return function wrapComponent(OriginalComponent) {
        var result = wrappingFunctions.reduceRight(function (component, wrappingFunction) {
            return wrappingFunction(component);
        }, OriginalComponent);
        return hoist_non_react_statics_1.default(result, OriginalComponent);
    };
}
exports.default = compose;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target, parent) {
  if (parent){
    return parent.querySelector(target);
  }
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target, parent) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target, parent);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(33);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertAt.before, target);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	if(options.attrs.nonce === undefined) {
		var nonce = getNonce();
		if (nonce) {
			options.attrs.nonce = nonce;
		}
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function getNonce() {
	if (false) {}

	return __webpack_require__.nc;
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = typeof options.transform === 'function'
		 ? options.transform(obj.css) 
		 : options.transform.default(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(82);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(13);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(51);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(58);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(14),
    eq = __webpack_require__(13);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(22);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(24),
    isLength = __webpack_require__(68);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isObject = __webpack_require__(8);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(44),
    createAssigner = __webpack_require__(75);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rangeslider = __webpack_require__(101);

var _Rangeslider2 = _interopRequireDefault(_Rangeslider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Rangeslider2.default;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__29__;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(126),
    isArrayLike = __webpack_require__(23),
    isString = __webpack_require__(127),
    toInteger = __webpack_require__(128),
    values = __webpack_require__(129);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(32);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control--ad-countdown {\n  align-content: flex-end;\n}\n.media-control--ad-countdown p {\n  width: 175px;\n  margin: 0 8px 0 0;\n  color: #fff;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-stretch: normal;\n  font-style: normal;\n  font-weight: normal;\n  letter-spacing: normal;\n  line-height: normal;\n  text-align: right;\n  text-transform: uppercase;\n}\n", ""]);

// exports


/***/ }),
/* 33 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(35);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(37),
    toKey = __webpack_require__(43);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(11),
    isKey = __webpack_require__(38),
    stringToPath = __webpack_require__(40),
    toString = __webpack_require__(42);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(11),
    isSymbol = __webpack_require__(39);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(41);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(45),
    assignMergeValue = __webpack_require__(19),
    baseFor = __webpack_require__(53),
    baseMergeDeep = __webpack_require__(55),
    isObject = __webpack_require__(8),
    keysIn = __webpack_require__(26),
    safeGet = __webpack_require__(25);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(46),
    listCacheDelete = __webpack_require__(47),
    listCacheGet = __webpack_require__(48),
    listCacheHas = __webpack_require__(49),
    listCacheSet = __webpack_require__(50);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(12);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(12);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(12);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(12);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(52);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(54);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(19),
    cloneBuffer = __webpack_require__(56),
    cloneTypedArray = __webpack_require__(59),
    copyArray = __webpack_require__(62),
    initCloneObject = __webpack_require__(63),
    isArguments = __webpack_require__(66),
    isArray = __webpack_require__(11),
    isArrayLikeObject = __webpack_require__(67),
    isBuffer = __webpack_require__(69),
    isFunction = __webpack_require__(24),
    isObject = __webpack_require__(8),
    isPlainObject = __webpack_require__(70),
    isTypedArray = __webpack_require__(71),
    safeGet = __webpack_require__(25),
    toPlainObject = __webpack_require__(72);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(15);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(57)(module)))

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(60);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(61);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(64),
    getPrototype = __webpack_require__(21),
    isPrototype = __webpack_require__(65);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(23),
    isObjectLike = __webpack_require__(17);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    getPrototype = __webpack_require__(21),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(73),
    keysIn = __webpack_require__(26);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(74),
    baseAssignValue = __webpack_require__(14);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(14),
    eq = __webpack_require__(13);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(76),
    isIterateeCall = __webpack_require__(81);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(77),
    overRest = __webpack_require__(78),
    setToString = __webpack_require__(80);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(79);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(83);
} else {}


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(85);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control {\n  display: inline;\n  border: 0;\n  background: none;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  cursor: pointer;\n  pointer-events: all;\n}\n.media-control-label {\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  border-radius: 2px;\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.media-control path,\n.media-control g {\n  opacity: 0.7;\n  fill: #FFFFFF;\n}\n.media-control-disable {\n  cursor: default;\n  pointer-events: none;\n}\n.media-control-disable path,\n.media-control-disable g {\n  opacity: 0.3;\n}\n.media-control:hover svg,\n.media-control:hover path,\n.media-control:hover g {\n  opacity: 1;\n}\n.media-control:active path,\n.media-control.active path,\n.media-control:active g,\n.media-control.active g {\n  opacity: 1;\n}\n", ""]);

// exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__createBinding", function() { return __createBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldGet", function() { return __classPrivateFieldGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__classPrivateFieldSet", function() { return __classPrivateFieldSet; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(88);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control-full-screen {\n  width: 32px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(90);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".controls-button-live {\n  width: 46px;\n  height: 24px;\n  margin: 0 10px;\n  line-height: 24px;\n}\n.controls-button-live--on {\n  background-color: #FFA800;\n}\n.controls-button-live--off {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n.controls-button-live--hide {\n  display: none;\n}\n", ""]);

// exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(92);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control--pause,\n.media-control--play {\n  width: 17px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(94);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control-quick-forward {\n  width: 28px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(96);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control-quick-rewind {\n  width: 28px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(98),
    isObject = __webpack_require__(8);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(8),
    now = __webpack_require__(99),
    toNumber = __webpack_require__(100);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(15);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(102);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _utils = __webpack_require__(103);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-debugger: "warn" */


/**
 * Predefined constants
 * @type {Object}
 */
var constants = {
  orientation: {
    horizontal: {
      dimension: 'width',
      direction: 'left',
      reverseDirection: 'right',
      coordinate: 'x'
    },
    vertical: {
      dimension: 'height',
      direction: 'top',
      reverseDirection: 'bottom',
      coordinate: 'y'
    }
  }
};

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props, context) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props, context));

    _this.handleFormat = function (value, percent) {
      var format = _this.props.format;

      return format ? format(value, percent) : value;
    };

    _this.handleUpdate = function () {
      if (!_this.slider) {
        // for shallow rendering
        return;
      }
      var orientation = _this.props.orientation;

      var dimension = (0, _utils.capitalize)(constants.orientation[orientation].dimension);
      var sliderPos = _this.slider['offset' + dimension];
      var handlePos = _this.handle['offset' + dimension];
      _this.setState({
        limit: sliderPos - handlePos,
        grab: handlePos / 2
      });
    };

    _this.handleStart = function (e) {
      var onChangeStart = _this.props.onChangeStart;

      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleEnd);
      _this.setState({
        active: true
      }, function () {
        onChangeStart && onChangeStart(e);
      });
    };

    _this.handleDrag = function (e) {
      e.stopPropagation();
      var onChange = _this.props.onChange;
      var _e$target = e.target,
          className = _e$target.className,
          classList = _e$target.classList,
          dataset = _e$target.dataset;

      if (!onChange || className === 'rangeslider__labels') return;

      var pos = _this.position(e);
      var percent = _this.getPercentFromPosition(pos);
      var value = _this.getValueFromPosition(pos);

      if (classList && classList.contains('rangeslider__label-item') && dataset.value) {
        value = parseFloat(dataset.value);
      }

      onChange && onChange(value, percent, e);
    };

    _this.handleMouseOver = function (e) {
      _this.setState({ active: true });
    };

    _this.handleMouseOut = function (e) {
      _this.setState({ active: false });
    };

    _this.handleEnd = function (e) {
      var onChangeComplete = _this.props.onChangeComplete;

      _this.setState({
        active: false
      }, function () {
        onChangeComplete && onChangeComplete(e);
      });
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleEnd);
    };

    _this.handleKeyDown = function (e) {
      e.preventDefault();
      var keyCode = e.keyCode;
      var _this$props = _this.props,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          onChange = _this$props.onChange;

      var sliderValue = void 0;

      switch (keyCode) {
        case 38:
        case 39:
          sliderValue = value + step > max ? max : value + step;
          onChange && onChange(sliderValue, e);
          break;
        case 37:
        case 40:
          sliderValue = value - step < min ? min : value - step;
          onChange && onChange(sliderValue, e);
          break;
      }
    };

    _this.getPositionFromValue = function (value) {
      var limit = _this.state.limit;
      var _this$props2 = _this.props,
          min = _this$props2.min,
          max = _this$props2.max;

      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;
      var pos = percentage * limit;

      return pos;
    };

    _this.getPercentFromPosition = function (pos) {
      var limit = _this.state.limit;

      return (0, _utils.clamp)(pos, 0, limit) / (limit || 1);
    };

    _this.getValueFromPosition = function (pos) {
      var _this$props3 = _this.props,
          orientation = _this$props3.orientation,
          min = _this$props3.min,
          max = _this$props3.max,
          step = _this$props3.step;

      var percentage = _this.getPercentFromPosition(pos);
      var baseVal = step * Math.round(percentage * (max - min) / step);
      var value = orientation === 'horizontal' ? baseVal + min : max - baseVal;

      return (0, _utils.clamp)(value, min, max);
    };

    _this.position = function (e) {
      var grab = _this.state.grab;
      var _this$props4 = _this.props,
          orientation = _this$props4.orientation,
          reverse = _this$props4.reverse;


      var node = _this.slider;
      var coordinateStyle = constants.orientation[orientation].coordinate;
      var directionStyle = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var clientCoordinateStyle = 'client' + (0, _utils.capitalize)(coordinateStyle);
      var coordinate = !e.touches ? e[clientCoordinateStyle] : e.touches[0][clientCoordinateStyle];
      var direction = node.getBoundingClientRect()[directionStyle];
      var pos = reverse ? direction - coordinate - grab : coordinate - direction - grab;

      return pos;
    };

    _this.coordinates = function (pos) {
      var _this$state = _this.state,
          limit = _this$state.limit,
          grab = _this$state.grab;
      var orientation = _this.props.orientation;

      var value = _this.getValueFromPosition(pos);
      var position = _this.getPositionFromValue(value);
      var handlePos = orientation === 'horizontal' ? position + grab : position;
      var fillPos = orientation === 'horizontal' ? handlePos : limit - handlePos;

      return {
        fill: fillPos,
        handle: handlePos,
        label: handlePos
      };
    };

    _this.renderLabels = function (labels) {
      return _react2.default.createElement(
        'ul',
        {
          ref: function ref(sl) {
            _this.labels = sl;
          },
          className: (0, _classnames2.default)('rangeslider__labels'),
          tabIndex: -1
        },
        labels
      );
    };

    _this.state = {
      active: false,
      limit: 0,
      grab: 0,
      percent: 0
    };
    return _this;
  }

  _createClass(Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleUpdate();
      var resizeObserver = new _resizeObserverPolyfill2.default(this.handleUpdate);
      resizeObserver.observe(this.slider);
    }

    /**
     * Format label/tooltip value
     * @param  {Number} - value
     * @return {Formatted Number}
     */


    /**
     * Update slider state on change
     * @return {void}
     */


    /**
     * Attach event listeners to mousemove/mouseup events
     * @return {void}
     */


    /**
     * Handle drag/mousemove event
     * @param  {Object} e - Event object
     * @return {void}
     */


    /**
     * Detach event listeners to mousemove/mouseup events
     * @return {void}
     */


    /**
     * Support for key events on the slider handle
     * @param  {Object} e - Event object
     * @return {void}
     */


    /**
     * Calculate position of slider based on its value
     * @param  {number} value - Current value of slider
     * @return {position} pos - Calculated position of slider based on value
     */


    /**
     * Translate position of slider to slider percent
     * @param  {number} pos - Current position/coordinates of slider
     * @return {number} percent - Slider percent
     */


    /**
     * Translate position of slider to slider value
     * @param  {number} pos - Current position/coordinates of slider
     * @return {number} value - Slider value
     */


    /**
     * Calculate position of slider based on value
     * @param  {Object} e - Event object
     * @return {number} value - Slider value
     */


    /**
     * Grab coordinates of slider
     * @param  {Object} pos - Position object
     * @return {Object} - Slider fill/handle coordinates
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          orientation = _props.orientation,
          className = _props.className,
          tooltip = _props.tooltip,
          reverse = _props.reverse,
          labels = _props.labels,
          min = _props.min,
          max = _props.max,
          ariaLabel = _props.ariaLabel,
          ariaValueText = _props.ariaValueText,
          ariaMin = _props.ariaMin,
          ariaMax = _props.ariaMax,
          ariaNow = _props.ariaNow,
          handleLabel = _props.handleLabel;
      var active = this.state.active;

      var dimension = constants.orientation[orientation].dimension;
      var direction = reverse ? constants.orientation[orientation].reverseDirection : constants.orientation[orientation].direction;
      var position = this.getPositionFromValue(value);
      var coords = this.coordinates(position);
      var percent = this.getPercentFromPosition(position);
      var fillStyle = _defineProperty({}, dimension, coords.fill + 'px');
      var handleStyle = _defineProperty({}, direction, coords.handle + 'px');
      var showTooltip = tooltip && active;

      var labelItems = [];
      var labelKeys = Object.keys(labels);

      if (labelKeys.length > 0) {
        labelKeys = labelKeys.sort(function (a, b) {
          return reverse ? a - b : b - a;
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = labelKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var labelPosition = this.getPositionFromValue(key);
            var labelCoords = this.coordinates(labelPosition);
            var labelStyle = _defineProperty({}, direction, labelCoords.label + 'px');

            labelItems.push(_react2.default.createElement(
              'li',
              {
                key: key,
                className: (0, _classnames2.default)('rangeslider__label-item'),
                'data-value': key,
                onMouseDown: this.handleDrag,
                onTouchStart: this.handleStart,
                onTouchEnd: this.handleEnd,
                style: labelStyle
              },
              this.props.labels[key]
            ));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(s) {
            _this2.slider = s;
          },
          className: (0, _classnames2.default)('rangeslider', 'rangeslider-' + orientation, { 'rangeslider-reverse': reverse }, className),
          onMouseDown: this.handleDrag,
          onMouseUp: this.handleEnd,
          onTouchStart: this.handleStart,
          onTouchEnd: this.handleEnd,
          tabIndex: this.props.tabIndex || 0,
          role: 'slider',
          'aria-label': ariaLabel,
          'aria-valuetext': ariaValueText,
          'aria-valuemin': ariaMin || min,
          'aria-valuemax': ariaMax || max,
          'aria-valuenow': ariaNow || value,
          'aria-orientation': orientation
        },
        _react2.default.createElement('div', { className: 'rangeslider__fill', style: fillStyle }),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(sh) {
              _this2.handle = sh;
            },
            className: 'rangeslider__handle',
            onMouseDown: this.handleStart,
            onTouchMove: this.handleDrag,
            onTouchEnd: this.handleEnd,
            onKeyDown: this.handleKeyDown,
            onMouseOver: this.handleMouseOver,
            onMouseOut: this.handleMouseOut,
            style: handleStyle,
            tabIndex: -1
          },
          showTooltip ? _react2.default.createElement(
            'div',
            {
              ref: function ref(st) {
                _this2.tooltip = st;
              },
              className: 'rangeslider__handle-tooltip'
            },
            _react2.default.createElement(
              'span',
              null,
              this.handleFormat(value, percent)
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { className: 'rangeslider__handle-label' },
            handleLabel
          )
        ),
        labels ? this.renderLabels(labelItems) : null
      );
    }
  }]);

  return Slider;
}(_react.Component);

Slider.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  ariaLabel: _propTypes2.default.string,
  ariaValueText: _propTypes2.default.string,
  ariaMin: _propTypes2.default.any,
  ariaMax: _propTypes2.default.any,
  ariaNow: _propTypes2.default.any,
  step: _propTypes2.default.number,
  value: _propTypes2.default.number,
  orientation: _propTypes2.default.string,
  tooltip: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  labels: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  handleLabel: _propTypes2.default.string,
  format: _propTypes2.default.func,
  onChangeStart: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onChangeComplete: _propTypes2.default.func
};
Slider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  value: 0,
  ariaLabel: '',
  ariaValueText: '',
  ariaMin: undefined,
  ariaMax: undefined,
  ariaNow: undefined,
  orientation: 'horizontal',
  tooltip: true,
  reverse: false,
  labels: {},
  handleLabel: ''
};
exports.default = Slider;

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.clamp = clamp;
/**
 * Capitalize first letter of string
 * @private
 * @param  {string} - String
 * @return {string} - String with first letter capitalized
 */
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
}

/**
 * Clamp position between a range
 * @param  {number} - Value to be clamped
 * @param  {number} - Minimum value in range
 * @param  {number} - Maximum value in range
 * @return {number} - Clamped value
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(105);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".rangeslider {\n  position: relative;\n  top: 0;\n  flex: 1 1 auto;\n  height: 10px;\n  margin: 10px 0;\n  border-radius: 3px;\n  background: url('data:image/png;base64,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') repeat-x;\n  cursor: pointer;\n}\n.rangeslider__fill {\n  height: 4px;\n  margin-top: 3px;\n  background: #1f7ac8;\n}\n.rangeslider__handle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 10px;\n  height: 10px;\n  margin-left: -5px;\n  transition: visibility 100ms, opacity 100ms;\n  border-radius: 50%;\n  background-color: #fff;\n}\n.rangeslider__handle:hover {\n  cursor: pointer;\n}\n.rangeslider__fill_buffer {\n  /* stylelint-disable-line */\n  position: absolute;\n  top: 13px;\n  left: 20px;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 0;\n  height: 4px;\n  padding-right: 20px;\n  padding-left: 20px;\n  background: #7a7e7a;\n  pointer-events: none;\n}\n.rangeslider__fill {\n  position: absolute;\n  z-index: 2;\n}\n.rangeslider__handle {\n  z-index: 3;\n}\n.rangeslider__handle-tooltip {\n  display: inline-block;\n  position: absolute;\n  top: -38px;\n  left: 50%;\n  width: 60px;\n  height: 26px;\n  transform: translate3d(-50%, 0, 0);\n  transition: all 100ms ease-in;\n  border: solid 2px #3f3f3f;\n  background-color: #000;\n  color: #fff;\n  font-size: 14px;\n  font-weight: normal;\n  text-align: center;\n}\n.rangeslider__handle-tooltip span {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 12px;\n  line-height: 100%;\n}\n.rangeslider__handle-tooltip::after,\n.rangeslider__handle-tooltip::before {\n  content: '  ';\n  position: absolute;\n  top: 21px;\n  z-index: 1;\n  width: 5px;\n  height: 5px;\n  margin: auto;\n  transform: rotate(45deg);\n  background-color: #000;\n}\n.rangeslider__handle-tooltip::before {\n  left: calc(50% - 8px);\n  z-index: 1;\n  border-right: 3px solid #000;\n  border-bottom: 3px solid #000;\n}\n.rangeslider__handle-tooltip::after {\n  top: 23px;\n  left: calc(50% - 8px);\n  z-index: 0;\n  border-right: 4px solid #3f3f3f;\n  border-bottom: 4px solid #3f3f3f;\n}\n", ""]);

// exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(107);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".scrubber-bar-wrapper {\n  display: inline-flex;\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(109);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control--timecode-display.disabled {\n  color: #BBBBBB;\n}\n", ""]);

// exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(111);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control--mute {\n  width: 32px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(113);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".rangeslider {\n  display: flex;\n  position: relative;\n  top: 0;\n  flex: 1 1 auto;\n  height: 10px;\n  margin: 5px 0;\n  border-radius: 3px;\n  background: url('data:image/png;base64,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') repeat-x;\n  cursor: pointer;\n}\n.rangeslider__fill {\n  height: 4px;\n  margin-top: 3px;\n  background: #1f7ac8;\n}\n.rangeslider__handle {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 10px;\n  height: 10px;\n  margin-left: -5px;\n  transition: visibility 100ms, opacity 100ms;\n  border-radius: 50%;\n  background-color: #fff;\n}\n.rangeslider__handle:hover {\n  cursor: pointer;\n}\n.rangeslider__fill_buffer {\n  /* stylelint-disable-line */\n  position: absolute;\n  top: 13px;\n  left: 20px;\n  z-index: 1;\n  box-sizing: border-box;\n  width: 0;\n  height: 4px;\n  padding-right: 20px;\n  padding-left: 20px;\n  background: #7a7e7a;\n  pointer-events: none;\n}\n.rangeslider__fill {\n  position: absolute;\n  z-index: 2;\n}\n.rangeslider__handle {\n  z-index: 3;\n}\n.rangeslider__handle-tooltip {\n  display: inline-block;\n  position: absolute;\n  top: -38px;\n  left: 50%;\n  width: 60px;\n  height: 26px;\n  transform: translate3d(-50%, 0, 0);\n  transition: all 100ms ease-in;\n  border: solid 2px #3f3f3f;\n  background-color: #000;\n  color: #fff;\n  font-size: 14px;\n  font-weight: normal;\n  text-align: center;\n}\n.rangeslider__handle-tooltip span {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 12px;\n  line-height: 100%;\n}\n.rangeslider__handle-tooltip::after,\n.rangeslider__handle-tooltip::before {\n  content: '  ';\n  position: absolute;\n  top: 21px;\n  z-index: 1;\n  width: 5px;\n  height: 5px;\n  margin: auto;\n  transform: rotate(45deg);\n  background-color: #000;\n}\n.rangeslider__handle-tooltip::before {\n  left: calc(50% - 8px);\n  z-index: 1;\n  border-right: 3px solid #000;\n  border-bottom: 3px solid #000;\n}\n.rangeslider__handle-tooltip::after {\n  top: 23px;\n  left: calc(50% - 8px);\n  z-index: 0;\n  border-right: 4px solid #3f3f3f;\n  border-bottom: 4px solid #3f3f3f;\n}\n.media-control-volume-slider {\n  width: 96px;\n}\n", ""]);

// exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(115);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".default-controls-layout button {\n  padding: 0;\n}\n.default-controls-layout .top-controls-container {\n  display: flex;\n  position: absolute;\n  top: 0;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n  padding: 10px 10px 0;\n}\n.default-controls-layout .bottom-controls-container {\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  box-sizing: border-box;\n  flex-direction: column;\n  width: 100%;\n  padding: 0 10px 10px;\n  transition-property: padding;\n  transition-duration: 0.5s;\n}\n.default-controls-layout .bottom-controls-container::after {\n  bottom: 0;\n  transition-property: opacity height;\n  transition-duration: 0.5s;\n  transition-timing-function: ease-in;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.95) 4%, rgba(12, 13, 25, 0));\n  content: '';\n  display: block;\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 110%;\n}\n.default-controls-layout .bottom-controls-container .bottom-controls {\n  display: flex;\n  height: 30px;\n  transition-property: opacity height;\n  transition-duration: 0.5s;\n}\n.default-controls-layout .bottom-controls-container.controls-hidden {\n  padding-bottom: 5px;\n  transition-property: padding;\n  transition-duration: 0.5s;\n}\n.default-controls-layout .bottom-controls-container .controls-hidden {\n  height: 0;\n  transition-property: opacity height;\n  transition-duration: 0.5s;\n  opacity: 0;\n}\n.default-controls-layout .duration-container {\n  display: flex;\n  justify-content: space-between;\n}\n.default-controls-layout .duration-container p {\n  margin: 0;\n  font-size: 14px;\n}\n.default-controls-layout .bottom-controls-left,\n.default-controls-layout .bottom-controls-right {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n}\n.default-controls-layout .bottom-controls-left .media-control {\n  margin-right: 12px;\n}\n.default-controls-layout .bottom-controls-right {\n  justify-content: flex-end;\n}\n.default-controls-layout .bottom-controls-right .media-control {\n  margin-left: 12px;\n}\n.default-controls-layout .controls-hidden::after {\n  transition-property: opacity height;\n  transition-duration: 0.5s;\n  opacity: 0;\n}\n", ""]);

// exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(117);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".closed-captions {\n  text-align: center;\n}\n.closed-captions .cue {\n  display: inline;\n  padding: 2px;\n  background-image: linear-gradient(to bottom, #000, #222);\n  color: #fff;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1.3em;\n}\n", ""]);

// exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(119);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".close-button {\n  width: 17px;\n  height: 17px;\n}\n.close-button svg {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(121);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".ad-controls-layout {\n  pointer-events: none;\n}\n.ad-controls-layout button {\n  padding: 0;\n}\n.ad-controls-layout .top-controls-container {\n  display: flex;\n  position: absolute;\n  top: 0;\n  box-sizing: border-box;\n  align-items: center;\n  width: 100%;\n}\n.ad-controls-layout .bottom-controls-container {\n  display: flex;\n  position: absolute;\n  bottom: 0;\n  box-sizing: border-box;\n  flex-direction: column;\n  width: 100%;\n  padding: 0 10px 20px;\n}\n.ad-controls-layout .bottom-controls-container::after {\n  content: '';\n  display: block;\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 150px;\n  bottom: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.95) 4%, rgba(12, 13, 25, 0));\n}\n.ad-controls-layout .bottom-controls-container .duration-container {\n  display: flex;\n  justify-content: space-between;\n}\n.ad-controls-layout .bottom-controls-container .bottom-controls {\n  display: flex;\n}\n.ad-controls-layout .bottom-controls-container .bottom-controls-left {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n}\n.ad-controls-layout .bottom-controls-container .bottom-controls-right {\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: flex-end;\n}\n", ""]);

// exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(123);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-control--ad-pause,\n.media-control--ad-play {\n  width: 17px;\n  height: 24px;\n}\n", ""]);

// exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(125);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".hidden {\n  display: none;\n}\n@keyframes load3 {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.mlb-player-controls-loader--container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 9999;\n  width: 100%;\n  height: 100%;\n  background-color: #000;\n  pointer-events: none;\n}\n.mlb-player-controls--loader {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  width: 11em;\n  height: 11em;\n  margin-top: -52px;\n  margin-left: -52px;\n  transform: translateZ(0);\n  animation: load3 1.4s infinite linear;\n  border-radius: 50%;\n  background: #fff;\n  background: linear-gradient(to right, #fff 10%, rgba(255, 255, 255, 0) 42%);\n  font-size: 10px;\n  pointer-events: none;\n}\n.mlb-player-controls--loader::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 50%;\n  height: 50%;\n  border-radius: 100% 0 0;\n  background: #fff;\n}\n.mlb-player-controls--loader::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 95%;\n  height: 95%;\n  margin: auto;\n  border-radius: 50%;\n  background: #000;\n}\n", ""]);

// exports


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(16),
    isArray = __webpack_require__(11),
    isObjectLike = __webpack_require__(17);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 128 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(130),
    keys = __webpack_require__(132);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(131);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(22);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(134);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(6)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {}

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".media-controls {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n}\n.media-controls-no-pointer-events {\n  pointer-events: none;\n}\n.media-controls p {\n  color: #FFFFFF;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.media-controls .media-control {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.media-controls .media-control svg {\n  transform: scale(0.85);\n}\n", ""]);

// exports


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "AdCountdown", function() { return /* reexport */ controls_ad_countdown; });
__webpack_require__.d(__webpack_exports__, "ButtonControl", function() { return /* reexport */ controls_button_control; });
__webpack_require__.d(__webpack_exports__, "ClosedCaptionsButton", function() { return /* reexport */ controls_closed_captions_button; });
__webpack_require__.d(__webpack_exports__, "FullscreenButton", function() { return /* reexport */ controls_fullscreen_button; });
__webpack_require__.d(__webpack_exports__, "JumpToLive", function() { return /* reexport */ controls_jump_to_live; });
__webpack_require__.d(__webpack_exports__, "PlayPauseButton", function() { return /* reexport */ play_pause; });
__webpack_require__.d(__webpack_exports__, "QuickForwardButton", function() { return /* reexport */ controls_quick_forward_button; });
__webpack_require__.d(__webpack_exports__, "QuickRewindButton", function() { return /* reexport */ controls_quick_rewind_button; });
__webpack_require__.d(__webpack_exports__, "ScrubberBar", function() { return /* reexport */ controls_scrubber_bar; });
__webpack_require__.d(__webpack_exports__, "Slider", function() { return /* reexport */ controls_slider; });
__webpack_require__.d(__webpack_exports__, "TimeDisplay", function() { return /* reexport */ time_display; });
__webpack_require__.d(__webpack_exports__, "MuteButton", function() { return /* reexport */ volume_mute_button; });
__webpack_require__.d(__webpack_exports__, "VolumeSlider", function() { return /* reexport */ volume_volume_slider; });
__webpack_require__.d(__webpack_exports__, "ControlsEvents", function() { return /* reexport */ controls_events; });
__webpack_require__.d(__webpack_exports__, "DefaultLayout", function() { return /* reexport */ layouts_default_layout; });
__webpack_require__.d(__webpack_exports__, "AdLayout", function() { return /* reexport */ layouts_ad_layout; });
__webpack_require__.d(__webpack_exports__, "LoadingSpinner", function() { return /* reexport */ overlays_loading_spinner; });
__webpack_require__.d(__webpack_exports__, "PlayerControls", function() { return /* reexport */ player_controls; });

// EXTERNAL MODULE: ./src/js/controls/ad-countdown/ad-countdown.less
var ad_countdown = __webpack_require__(31);

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
var external_commonjs_react_commonjs2_react_amd_react_root_React_ = __webpack_require__(0);
var external_commonjs_react_commonjs2_react_amd_react_root_React_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_amd_react_root_React_);

// EXTERNAL MODULE: external {"root":["rxjs","operators"],"commonjs":"rxjs/operators","commonjs2":"rxjs/operators","amd":"rxjs/operators"}
var operators_ = __webpack_require__(7);

// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/prop-types/index.js
var prop_types = __webpack_require__(1);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./src/js/controls/ad-countdown/ad-countdown.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

 //import { AdvertisingPluginEvents } from 'mlb-player-plugins';



/**
 *
 * Displays a countdown timer and text to be displayed during ad playback
 * ```js
 * <AdCountdown mediaPlayer={this.props.mediaPlayer} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.adCountdown = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component AdCountdown
 * @module AdCountdown
 *
 */

var ad_countdown_AdCountdown = /*#__PURE__*/function (_Component) {
  _inherits(AdCountdown, _Component);

  var _super = _createSuper(AdCountdown);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function AdCountdown(props) {
    var _this;

    _classCallCheck(this, AdCountdown);

    _this = _super.call(this, props);
    _this.state = {
      seconds: 0
    };
    _this.subscriptions = [];
    return _this;
  }

  _createClass(AdCountdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
      this.subscriptions = [];
    }
    /**
     *
     * Subscribes to pluginSubject for the `AdvertisingPluginEvents.AD_TIME_UPDATE_REMAINING` (`adTimeUpdateElapsed`) event stream
     * @private
     *
     */

  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var subscription = this.props.mediaPlayer.observationCenter.pluginSubject.pipe(Object(operators_["filter"])(function (message) {
        return message.type === 'adTimeUpdateElapsed'; //AdvertisingPluginEvents.AD_TIME_UPDATE_REMAINING;
      })).subscribe(function (message) {
        _this2.setState({
          seconds: message.countdown
        });
      });
      this.subscriptions.push(subscription);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
    /**
     *
     * @desc Render the current time
     *
     */

  }, {
    key: "render",
    value: function render() {
      var seconds = Math.round(this.state.seconds);
      var timeDescription = seconds === 1 ? 'second' : 'seconds';
      var countDownMessage = "".concat(seconds, " ").concat(timeDescription, " remaining");
      return seconds > 0 ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "media-control media-control--ad-countdown"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("p", {
        "aria-label": countDownMessage
      }, countDownMessage)) : null;
    }
  }]);

  return AdCountdown;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

ad_countdown_AdCountdown.componentId = 'adCountdown';
ad_countdown_AdCountdown.propTypes = {
  /** The MediaPlayer instance */
  mediaPlayer: prop_types_default.a.object
};
ad_countdown_AdCountdown.defaultProps = {
  mediaPlayer: undefined
};
/* harmony default export */ var ad_countdown_ad_countdown = (ad_countdown_AdCountdown);
// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/lodash/get.js
var get = __webpack_require__(2);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/lodash/merge.js
var merge = __webpack_require__(27);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(9);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ./src/js/util/with-config-hoc.js
function with_config_hoc_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { with_config_hoc_typeof = function _typeof(obj) { return typeof obj; }; } else { with_config_hoc_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return with_config_hoc_typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function with_config_hoc_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function with_config_hoc_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function with_config_hoc_createClass(Constructor, protoProps, staticProps) { if (protoProps) with_config_hoc_defineProperties(Constructor.prototype, protoProps); if (staticProps) with_config_hoc_defineProperties(Constructor, staticProps); return Constructor; }

function with_config_hoc_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) with_config_hoc_setPrototypeOf(subClass, superClass); }

function with_config_hoc_setPrototypeOf(o, p) { with_config_hoc_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return with_config_hoc_setPrototypeOf(o, p); }

function with_config_hoc_createSuper(Derived) { var hasNativeReflectConstruct = with_config_hoc_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = with_config_hoc_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = with_config_hoc_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return with_config_hoc_possibleConstructorReturn(this, result); }; }

function with_config_hoc_possibleConstructorReturn(self, call) { if (call && (with_config_hoc_typeof(call) === "object" || typeof call === "function")) { return call; } return with_config_hoc_assertThisInitialized(self); }

function with_config_hoc_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function with_config_hoc_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function with_config_hoc_getPrototypeOf(o) { with_config_hoc_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return with_config_hoc_getPrototypeOf(o); }






var with_config_hoc_withConfig = function withConfig() {
  var defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    var configPath = "mediaPlayer.config.controlsConfig.".concat(WrappedComponent.componentId);

    var WithConfig = /*#__PURE__*/function (_Component) {
      with_config_hoc_inherits(WithConfig, _Component);

      var _super = with_config_hoc_createSuper(WithConfig);

      function WithConfig() {
        with_config_hoc_classCallCheck(this, WithConfig);

        return _super.apply(this, arguments);
      }

      with_config_hoc_createClass(WithConfig, [{
        key: "render",
        value: function render() {
          var userConfig = get_default()(this.props, configPath, {});

          var config = merge_default()({}, defaultConfig, userConfig);

          var mustShow = get_default()(config, 'enabled', true);

          return mustShow ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(WrappedComponent, _extends({
            config: config
          }, this.props)) : null;
        }
      }]);

      return WithConfig;
    }(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

    ;
    hoist_non_react_statics_cjs_default()(WithConfig, WrappedComponent);
    return WithConfig;
  };
};

/* harmony default export */ var with_config_hoc = (with_config_hoc_withConfig);
// CONCATENATED MODULE: ./src/js/controls/ad-countdown/index.js



/* harmony default export */ var controls_ad_countdown = (with_config_hoc()(ad_countdown_ad_countdown));
// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/classnames/index.js
var classnames = __webpack_require__(3);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/js/controls/button-control/button-control.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 *
 * Base button control component.
 * ```js
 * <ButtonControl onClick={this.props.onClick}
 *  label={this.props.label}
 *  ariaLabel={this.props.ariaLabel}
 *  className={this.props.className}>
 * ```
 * @component ButtonControl
 * @module ButtonControl
 *
 */

function ButtonControl(props) {
  var onClick = props.onClick,
      active = props.active,
      label = props.label,
      className = props.className,
      ariaLabel = props.ariaLabel,
      ariaPressed = props.ariaPressed,
      tabIndex = props.tabIndex;
  var classes = classnames_default()(_defineProperty({
    'media-control': true,
    active: active
  }, className, true));
  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("button", {
    "aria-label": ariaLabel,
    className: classes,
    onClick: onClick,
    "aria-pressed": ariaPressed,
    tabIndex: tabIndex || 0
  }, props.children);
}

ButtonControl.propTypes = {
  /** CSS class to be applied */
  className: prop_types_default.a.string,

  /** Click handler function */
  onClick: prop_types_default.a.func,

  /** If the button is active or not. Active is available to user input. */
  active: prop_types_default.a.bool,

  /** The label to be displayed. */
  label: prop_types_default.a.string.isRequired,

  /** The ARIA label to be applied to the control. */
  ariaLabel: prop_types_default.a.string,

  /** The ARIA button has been pressed */
  ariaPressed: prop_types_default.a.bool,

  /** The controls tabindex */
  tabIndex: prop_types_default.a.number
};
ButtonControl.defaultProps = {
  className: '',
  onClick: null,
  active: false,
  ariaLabel: '',
  ariaPressed: false,
  tabIndex: 0
};
/* harmony default export */ var button_control = (ButtonControl);
// EXTERNAL MODULE: ./src/js/controls/button-control/button-control.less
var button_control_button_control = __webpack_require__(84);

// CONCATENATED MODULE: ./src/js/controls/button-control/index.js


/* harmony default export */ var controls_button_control = (button_control);
// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/@shopify/react-compose/dist/index.js
var dist = __webpack_require__(4);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./src/images/icons/closed-captions-icon.svg
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function closed_captions_icon_extends() {
  closed_captions_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return closed_captions_icon_extends.apply(this, arguments);
}


/* harmony default export */ var closed_captions_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", closed_captions_icon_extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "24"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    className: styles["st0"] || "st0",
    d: "M29 3v18H3V3h26m1-3H2C.9 0 0 .9 0 2v20c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    className: styles["st0"] || "st0",
    d: "M7 12c0-3 1.7-4.8 4.4-4.8 2.2 0 4 1.4 4.1 3.5h-1.9c-.2-1.1-1.1-1.9-2.2-1.9C9.9 8.8 9 10 9 12s.9 3.2 2.4 3.2c1.2 0 2-.7 2.2-1.8h1.9c-.2 2.1-1.8 3.4-4.1 3.4C8.7 16.8 7 15 7 12zm9.5 0c0-3 1.7-4.8 4.4-4.8 2.2 0 4 1.4 4.1 3.5h-1.9c-.2-1.1-1.1-1.9-2.2-1.9-1.5 0-2.4 1.2-2.4 3.2s.9 3.2 2.4 3.2c1.2 0 2-.7 2.2-1.8H25c-.2 2.1-1.8 3.4-4.1 3.4-2.7 0-4.4-1.8-4.4-4.8z"
  }));
});
// CONCATENATED MODULE: ./src/js/controls/closed-captions-button/closed-captions-button.js
function closed_captions_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { closed_captions_button_typeof = function _typeof(obj) { return typeof obj; }; } else { closed_captions_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return closed_captions_button_typeof(obj); }

function closed_captions_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function closed_captions_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function closed_captions_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) closed_captions_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) closed_captions_button_defineProperties(Constructor, staticProps); return Constructor; }

function closed_captions_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) closed_captions_button_setPrototypeOf(subClass, superClass); }

function closed_captions_button_setPrototypeOf(o, p) { closed_captions_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return closed_captions_button_setPrototypeOf(o, p); }

function closed_captions_button_createSuper(Derived) { var hasNativeReflectConstruct = closed_captions_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = closed_captions_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = closed_captions_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return closed_captions_button_possibleConstructorReturn(this, result); }; }

function closed_captions_button_possibleConstructorReturn(self, call) { if (call && (closed_captions_button_typeof(call) === "object" || typeof call === "function")) { return call; } return closed_captions_button_assertThisInitialized(self); }

function closed_captions_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function closed_captions_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function closed_captions_button_getPrototypeOf(o) { closed_captions_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return closed_captions_button_getPrototypeOf(o); }

function closed_captions_button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 *
 * Button to enable/disable captions and sub-titles.
 * ```js
 * <ClosedCaptionsButton
 *  mediaPlayer={this.props.mediaPlayer}
 *  closedCaptionsActive={this.props.closedCaptionsActive}
 *  hasClosedCaptions={this.props.hasClosedCaptions} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.closedCaptionsButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component ClosedCaptionsButton
 * @module ClosedCaptionsButton
 *
 */

var closed_captions_button_ClosedCaptionsButton = /*#__PURE__*/function (_Component) {
  closed_captions_button_inherits(ClosedCaptionsButton, _Component);

  var _super = closed_captions_button_createSuper(ClosedCaptionsButton);

  function ClosedCaptionsButton() {
    var _this;

    closed_captions_button_classCallCheck(this, ClosedCaptionsButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    closed_captions_button_defineProperty(closed_captions_button_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          closedCaptionsActive = _this$props.closedCaptionsActive,
          mediaPlayer = _this$props.mediaPlayer;

      if (closedCaptionsActive) {
        mediaPlayer.hideClosedCaptions();
      } else {
        mediaPlayer.showClosedCaptions();
      }
    });

    return _this;
  }

  closed_captions_button_createClass(ClosedCaptionsButton, [{
    key: "render",
    value:
    /**
     *
     * @desc render the closed captions button
     *
     */
    function render() {
      var _this$props2 = this.props,
          hasClosedCaptions = _this$props2.hasClosedCaptions,
          active = _this$props2.closedCaptionsActive;
      var label = "Subtitles/Closed captions (c)";
      var classes = classnames_default()({
        'media-control-closed-captions': true,
        active: active
      });
      return hasClosedCaptions ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: label,
        className: classes,
        ariaPressed: active
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(closed_captions_icon, null)) : null;
    }
  }]);

  return ClosedCaptionsButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

closed_captions_button_ClosedCaptionsButton.componentId = 'closedCaptionsButton';
closed_captions_button_ClosedCaptionsButton.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  hasClosedCaptions: prop_types_default.a.bool,
  closedCaptionsActive: prop_types_default.a.bool
};
closed_captions_button_ClosedCaptionsButton.defaultProps = {
  mediaPlayer: undefined,
  hasClosedCaptions: false,
  closedCaptionsActive: false
};
/* harmony default export */ var closed_captions_button = (closed_captions_button_ClosedCaptionsButton);
// CONCATENATED MODULE: ./src/js/util/with-focus-hoc.js
function with_focus_hoc_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { with_focus_hoc_typeof = function _typeof(obj) { return typeof obj; }; } else { with_focus_hoc_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return with_focus_hoc_typeof(obj); }

function with_focus_hoc_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function with_focus_hoc_extends() { with_focus_hoc_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return with_focus_hoc_extends.apply(this, arguments); }

function with_focus_hoc_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function with_focus_hoc_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function with_focus_hoc_createClass(Constructor, protoProps, staticProps) { if (protoProps) with_focus_hoc_defineProperties(Constructor.prototype, protoProps); if (staticProps) with_focus_hoc_defineProperties(Constructor, staticProps); return Constructor; }

function with_focus_hoc_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) with_focus_hoc_setPrototypeOf(subClass, superClass); }

function with_focus_hoc_setPrototypeOf(o, p) { with_focus_hoc_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return with_focus_hoc_setPrototypeOf(o, p); }

function with_focus_hoc_createSuper(Derived) { var hasNativeReflectConstruct = with_focus_hoc_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = with_focus_hoc_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = with_focus_hoc_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return with_focus_hoc_possibleConstructorReturn(this, result); }; }

function with_focus_hoc_possibleConstructorReturn(self, call) { if (call && (with_focus_hoc_typeof(call) === "object" || typeof call === "function")) { return call; } return with_focus_hoc_assertThisInitialized(self); }

function with_focus_hoc_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function with_focus_hoc_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function with_focus_hoc_getPrototypeOf(o) { with_focus_hoc_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return with_focus_hoc_getPrototypeOf(o); }




var FocusContext = /*#__PURE__*/Object(external_commonjs_react_commonjs2_react_amd_react_root_React_["createContext"])({
  focusedId: null,
  playerId: null,
  isMediaPlayer: false,
  usesArrowKeys: false,
  isButton: false,
  managedFocus: function managedFocus(_managedFocus) {
    this.isMediaPlayer = _managedFocus;
  },
  focusSwitched: function focusSwitched(id, playerId, features) {
    this.focusedId = id;
    this.playerId = playerId;
    this.usesArrowKeys = !!features.usesArrowKeys;
    this.isButton = !!features.isButton;
  },
  focusLost: function focusLost() {
    this.focusedId = null;
    this.playerId = null;
    this.usesArrowKeys = false;
    this.isButton = false;
  }
});
function focusConsumer(WrappedComponent) {
  var WithFocusConsumer = /*#__PURE__*/function (_Component) {
    with_focus_hoc_inherits(WithFocusConsumer, _Component);

    var _super = with_focus_hoc_createSuper(WithFocusConsumer);

    function WithFocusConsumer() {
      with_focus_hoc_classCallCheck(this, WithFocusConsumer);

      return _super.apply(this, arguments);
    }

    with_focus_hoc_createClass(WithFocusConsumer, [{
      key: "render",
      value: function render() {
        var _this = this;

        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(FocusContext.Consumer, null, function (focus) {
          return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(WrappedComponent, with_focus_hoc_extends({
            focus: focus
          }, _this.props));
        });
      }
    }]);

    return WithFocusConsumer;
  }(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

  ;
  hoist_non_react_statics_cjs_default()(WithFocusConsumer, WrappedComponent);
  return WithFocusConsumer;
}
;

var with_focus_hoc_withFocus = function withFocus() {
  var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (WrappedComponent) {
    var WithFocus = /*#__PURE__*/function (_Component2) {
      with_focus_hoc_inherits(WithFocus, _Component2);

      var _super2 = with_focus_hoc_createSuper(WithFocus);

      function WithFocus() {
        var _this2;

        with_focus_hoc_classCallCheck(this, WithFocus);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        with_focus_hoc_defineProperty(with_focus_hoc_assertThisInitialized(_this2), "_onFocus", function () {
          var playerId = _this2.props.mediaPlayer.getPlayerId();

          _this2.context.focusSwitched(WrappedComponent.componentId, playerId, features);
        });

        with_focus_hoc_defineProperty(with_focus_hoc_assertThisInitialized(_this2), "_onBlur", function () {
          _this2.context.focusLost(WrappedComponent.componentId);
        });

        return _this2;
      }

      with_focus_hoc_createClass(WithFocus, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
            onFocus: this._onFocus,
            onBlur: this._onBlur
          }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(WrappedComponent, this.props));
        }
      }]);

      return WithFocus;
    }(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

    with_focus_hoc_defineProperty(WithFocus, "contextType", FocusContext);

    ;
    hoist_non_react_statics_cjs_default()(WithFocus, WrappedComponent);
    return WithFocus;
  };
};

/* harmony default export */ var with_focus_hoc = (with_focus_hoc_withFocus);
// CONCATENATED MODULE: ./src/js/controls/closed-captions-button/index.js




/* harmony default export */ var controls_closed_captions_button = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(closed_captions_button));
// EXTERNAL MODULE: ./src/js/controls/fullscreen-button/fullscreen-button.less
var fullscreen_button = __webpack_require__(87);

// CONCATENATED MODULE: ./src/images/icons/enter-fullscreen-icon.svg
function enter_fullscreen_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = enter_fullscreen_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function enter_fullscreen_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function enter_fullscreen_icon_extends() {
  enter_fullscreen_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return enter_fullscreen_icon_extends.apply(this, arguments);
}


/* harmony default export */ var enter_fullscreen_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = enter_fullscreen_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", enter_fullscreen_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "24"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M32 15v9H19v-3h10v-6h3zm0-6h-3V3H19V0h13v9zM0 15h3v6h10v3H0v-9zm0-6V0h13v3H3v6H0z",
    fill: "#fff"
  }));
});
// CONCATENATED MODULE: ./src/images/icons/exit-fullscreen-icon.svg
function exit_fullscreen_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = exit_fullscreen_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function exit_fullscreen_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function exit_fullscreen_icon_extends() {
  exit_fullscreen_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return exit_fullscreen_icon_extends.apply(this, arguments);
}


/* harmony default export */ var exit_fullscreen_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = exit_fullscreen_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", exit_fullscreen_icon_extends({
    version: "1.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32",
    height: "24"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "a",
    d: "M-51.3 22.7h-4.9c-1 0-1.8-.7-1.8-1.5V15c0-.9.8-1.5 1.8-1.5h4.8L-46 9c.3-.2.5-.1.5.2V27c0 .3-.2.5-.5.2l-5.3-4.5z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "c",
    d: "M-53.5 6c.6-.6 1.5-.6 2.1 0l21.9 21.9c.6.6.6 1.5 0 2.1-.6.6-1.5.6-2.1 0L-53.5 8.1c-.6-.6-.6-1.5 0-2.1z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "e",
    d: "M0 0h32v24H0z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "g",
    d: "M22 6h10v3H19V0h3v6zM10 9H0V6h10V0h3v9h-3z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#g",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "i",
    d: "M0 0h32v24H0z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    clipPath: "url(#j)",
    fill: "#FFF",
    d: "M-5-5h42v19H-5z"
  }))), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "k",
    d: "M22 15h10v3H22v6h-3v-9h3zm-12 3H0v-3h13v9h-3v-6z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#k",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("defs", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    id: "m",
    d: "M0 0h32v24H0z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    clipPath: "url(#n)",
    fill: "#FFF",
    d: "M-5 10h42v19H-5z"
  })))));
});
// CONCATENATED MODULE: ./src/js/controls/fullscreen-button/fullscreen-button.js
function fullscreen_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { fullscreen_button_typeof = function _typeof(obj) { return typeof obj; }; } else { fullscreen_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return fullscreen_button_typeof(obj); }

function fullscreen_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function fullscreen_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function fullscreen_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) fullscreen_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) fullscreen_button_defineProperties(Constructor, staticProps); return Constructor; }

function fullscreen_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) fullscreen_button_setPrototypeOf(subClass, superClass); }

function fullscreen_button_setPrototypeOf(o, p) { fullscreen_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return fullscreen_button_setPrototypeOf(o, p); }

function fullscreen_button_createSuper(Derived) { var hasNativeReflectConstruct = fullscreen_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = fullscreen_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = fullscreen_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return fullscreen_button_possibleConstructorReturn(this, result); }; }

function fullscreen_button_possibleConstructorReturn(self, call) { if (call && (fullscreen_button_typeof(call) === "object" || typeof call === "function")) { return call; } return fullscreen_button_assertThisInitialized(self); }

function fullscreen_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function fullscreen_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function fullscreen_button_getPrototypeOf(o) { fullscreen_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return fullscreen_button_getPrototypeOf(o); }







/**
 *
 * Enable/disable fullscreen player. Calls `enterFullscreen()` or `exitFullscreen()` based on player state when clicked.
 * ```js
 * <FullscreenButton
 *  mediaPlayer={this.props.mediaPlayer}
 *  isFullscreen={this.props.isFullscreen}
 *  fullscreenElement={this.props.fullscreenElement} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.fullscreenButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component FullscreenButton
 * @module FullscreenButton
 *
 */

var fullscreen_button_FullscreenButton = /*#__PURE__*/function (_Component) {
  fullscreen_button_inherits(FullscreenButton, _Component);

  var _super = fullscreen_button_createSuper(FullscreenButton);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function FullscreenButton(props) {
    var _this;

    fullscreen_button_classCallCheck(this, FullscreenButton);

    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(fullscreen_button_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   * @desc onCLick fullscreen handler. If not in fullscreen, requests fullscreen for the specified element.
   * Otherwise exits fullscreen.
   *
   */


  fullscreen_button_createClass(FullscreenButton, [{
    key: "onClick",
    value: function onClick() {
      if (this.props.isFullscreen) {
        this.props.mediaPlayer.exitFullscreen();
      } else {
        this.props.mediaPlayer.requestFullscreen(this.props.fullscreenElement);
      }
    }
    /**
     *
     * @desc render the fullscreen component
     *
     */

  }, {
    key: "render",
    value: function render() {
      var isFullscreen = this.props.isFullscreen;
      var label = 'Fullscreen';

      if (isFullscreen) {
        label = 'Exit Full Screen';
      } else {
        label = 'Full Screen';
      }

      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: "Fullscreen (f)",
        ariaPressed: isFullscreen,
        className: "media-control-full-screen"
      }, isFullscreen ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(exit_fullscreen_icon, null) : /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(enter_fullscreen_icon, null));
    }
  }]);

  return FullscreenButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

fullscreen_button_FullscreenButton.componentId = 'fullscreenButton';
fullscreen_button_FullscreenButton.propTypes = {
  /** If the player is in fullscreen or not */
  isFullscreen: prop_types_default.a.bool,

  /** The element that will be toggled to fullscreen */
  fullscreenElement: prop_types_default.a.instanceOf(Element)
};
fullscreen_button_FullscreenButton.defaultProps = {
  isFullscreen: false,
  fullscreenElement: undefined
};
/* harmony default export */ var fullscreen_button_fullscreen_button = (fullscreen_button_FullscreenButton);
// CONCATENATED MODULE: ./src/js/controls/fullscreen-button/index.js





/* harmony default export */ var controls_fullscreen_button = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(fullscreen_button_fullscreen_button));
// EXTERNAL MODULE: ./src/js/controls/jump-to-live/jump-to-live.less
var jump_to_live = __webpack_require__(89);

// CONCATENATED MODULE: ./src/js/controls/jump-to-live/jump-to-live.js
function jump_to_live_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { jump_to_live_typeof = function _typeof(obj) { return typeof obj; }; } else { jump_to_live_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return jump_to_live_typeof(obj); }

function jump_to_live_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function jump_to_live_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function jump_to_live_createClass(Constructor, protoProps, staticProps) { if (protoProps) jump_to_live_defineProperties(Constructor.prototype, protoProps); if (staticProps) jump_to_live_defineProperties(Constructor, staticProps); return Constructor; }

function jump_to_live_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) jump_to_live_setPrototypeOf(subClass, superClass); }

function jump_to_live_setPrototypeOf(o, p) { jump_to_live_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return jump_to_live_setPrototypeOf(o, p); }

function jump_to_live_createSuper(Derived) { var hasNativeReflectConstruct = jump_to_live_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = jump_to_live_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = jump_to_live_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return jump_to_live_possibleConstructorReturn(this, result); }; }

function jump_to_live_possibleConstructorReturn(self, call) { if (call && (jump_to_live_typeof(call) === "object" || typeof call === "function")) { return call; } return jump_to_live_assertThisInitialized(self); }

function jump_to_live_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function jump_to_live_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function jump_to_live_getPrototypeOf(o) { jump_to_live_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return jump_to_live_getPrototypeOf(o); }






/**
 *
 * For live feeds, handles jumping to the "live point". Also UI updates to indicate at live point or not.
 * ```js
 * <JumpToLiveButton
 *  mediaPlayer={this.props.mediaPlayer}
 *  isLive={this.props.isLive}
 *  isAtLivePoint={this.props.isAtLivePoint}
 *  className={this.props.className}/>
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.jumpToLiveButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component JumpToLiveButton
 * @module JumpToLiveButton
 *
 */

var jump_to_live_JumpToLiveButton = /*#__PURE__*/function (_Component) {
  jump_to_live_inherits(JumpToLiveButton, _Component);

  var _super = jump_to_live_createSuper(JumpToLiveButton);

  function JumpToLiveButton(props) {
    var _this;

    jump_to_live_classCallCheck(this, JumpToLiveButton);

    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(jump_to_live_assertThisInitialized(_this));
    return _this;
  }

  jump_to_live_createClass(JumpToLiveButton, [{
    key: "onClick",
    value: function onClick() {
      this.props.mediaPlayer.jumpToLive();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isLive = _this$props.isLive,
          isAtLivePoint = _this$props.isAtLivePoint;
      var buttonClass = classnames_default()('media-control-label', 'controls-button-live', {
        'controls-button-live--on': isAtLivePoint,
        'controls-button-live--off': !isAtLivePoint,
        'controls-button-live--hide': !isLive
      });
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(button_control, {
        onClick: this.onClick,
        label: "Live",
        ariaLabel: "Jump to live point",
        className: buttonClass,
        active: !isAtLivePoint,
        tabIndex: isAtLivePoint ? -1 : 0
      }, "Live");
    }
  }]);

  return JumpToLiveButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

jump_to_live_JumpToLiveButton.componentId = 'jumpToLiveButton';
jump_to_live_JumpToLiveButton.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  isLive: prop_types_default.a.bool,
  isAtLivePoint: prop_types_default.a.bool
};
jump_to_live_JumpToLiveButton.defaultProps = {
  mediaPlayer: undefined,
  isLive: false,
  isAtLivePoint: false
};
/* harmony default export */ var jump_to_live_jump_to_live = (jump_to_live_JumpToLiveButton);
// CONCATENATED MODULE: ./src/js/controls/jump-to-live/index.js





/* harmony default export */ var controls_jump_to_live = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(jump_to_live_jump_to_live));
// EXTERNAL MODULE: ./src/js/controls/play-pause/play-pause-button.less
var play_pause_button = __webpack_require__(91);

// CONCATENATED MODULE: ./src/images/icons/play-icon.svg
function play_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = play_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function play_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function play_icon_extends() {
  play_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return play_icon_extends.apply(this, arguments);
}


/* harmony default export */ var play_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = play_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", play_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.7",
    height: "25"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M1.6.2l14.3 10.7c.9.7 1.1 1.9.4 2.8-.1.2-.2.3-.4.4L1.6 24.8c-.4.3-1.1.2-1.4-.2-.1-.2-.2-.4-.2-.6V1c0-.6.4-1 1-1 .2 0 .4.1.6.2z",
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    overflow: "visible"
  }));
});
// CONCATENATED MODULE: ./src/images/icons/pause-icon.svg
function pause_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = pause_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function pause_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function pause_icon_extends() {
  pause_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return pause_icon_extends.apply(this, arguments);
}


/* harmony default export */ var pause_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = pause_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", pause_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "24"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M11 0h2c.6 0 1 .4 1 1v22c0 .6-.4 1-1 1h-2c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1zM1 0h2c.6 0 1 .4 1 1v22c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1z",
    fill: "#fff"
  }));
});
// CONCATENATED MODULE: ./src/js/controls/play-pause/play-pause-button.js
function play_pause_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { play_pause_button_typeof = function _typeof(obj) { return typeof obj; }; } else { play_pause_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return play_pause_button_typeof(obj); }

function play_pause_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function play_pause_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function play_pause_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) play_pause_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) play_pause_button_defineProperties(Constructor, staticProps); return Constructor; }

function play_pause_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) play_pause_button_setPrototypeOf(subClass, superClass); }

function play_pause_button_setPrototypeOf(o, p) { play_pause_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return play_pause_button_setPrototypeOf(o, p); }

function play_pause_button_createSuper(Derived) { var hasNativeReflectConstruct = play_pause_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = play_pause_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = play_pause_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return play_pause_button_possibleConstructorReturn(this, result); }; }

function play_pause_button_possibleConstructorReturn(self, call) { if (call && (play_pause_button_typeof(call) === "object" || typeof call === "function")) { return call; } return play_pause_button_assertThisInitialized(self); }

function play_pause_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function play_pause_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function play_pause_button_getPrototypeOf(o) { play_pause_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return play_pause_button_getPrototypeOf(o); }

function play_pause_button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/**
 *
 * Displays a play or pause button based on the playerState.paused value
 * ```js
 * <PlayPauseButton
 *     mediaPlayer={mediaPlayer}
 *     isPaused={paused}
 *     className="media-control" />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.playPauseButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @module PlayPauseButton
 * @component PlayPauseButton
 *
 */

var play_pause_button_PlayPauseButton = /*#__PURE__*/function (_Component) {
  play_pause_button_inherits(PlayPauseButton, _Component);

  var _super = play_pause_button_createSuper(PlayPauseButton);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function PlayPauseButton(props) {
    var _this;

    play_pause_button_classCallCheck(this, PlayPauseButton);

    _this = _super.call(this, props);

    play_pause_button_defineProperty(play_pause_button_assertThisInitialized(_this), "onClick", function (event) {
      var isPaused = _this.props.isPaused;

      if (isPaused) {
        _this.props.mediaPlayer.play();
      } else {
        _this.props.mediaPlayer.pause();
      }
    });

    return _this;
  }

  play_pause_button_createClass(PlayPauseButton, [{
    key: "render",
    value:
    /**
     *
     * @desc Render the PlayButton or PauseButton based on the playerState.paused property
     *
     */
    function render() {
      var isPaused = this.props.isPaused;
      var label = isPaused ? 'Play' : 'Pause';
      var ariaLabel = isPaused ? 'Play (space)' : 'Pause (space)';
      var className = isPaused ? 'media-control--play' : 'media-control--pause';
      var icon = isPaused ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(play_icon, null) : /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(pause_icon, null);
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: ariaLabel,
        className: className
      }, icon);
    }
  }]);

  return PlayPauseButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

play_pause_button_PlayPauseButton.componentId = 'playPauseButton';
play_pause_button_PlayPauseButton.propTypes = {
  /** If the player is paused or not */
  isPaused: prop_types_default.a.bool
};
play_pause_button_PlayPauseButton.defaultProps = {
  isPaused: false
};
/* harmony default export */ var play_pause_play_pause_button = (play_pause_button_PlayPauseButton);
// CONCATENATED MODULE: ./src/js/controls/play-pause/index.js





/* harmony default export */ var play_pause = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(play_pause_play_pause_button));
// EXTERNAL MODULE: ./src/js/controls/quick-forward-button/quick-forward-button.less
var quick_forward_button = __webpack_require__(93);

// CONCATENATED MODULE: ./src/images/icons/quick-forward-icon.svg
function quick_forward_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = quick_forward_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function quick_forward_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function quick_forward_icon_extends() {
  quick_forward_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return quick_forward_icon_extends.apply(this, arguments);
}


/* harmony default export */ var quick_forward_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = quick_forward_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", quick_forward_icon_extends({
    version: "1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "24"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M6.7 11.6v-.7c.6-.1 1.1-.2 1.3-.3.2-.1.4-.5.6-1h.7v6.9h-1v-4.9H6.7zm5.3 3.1c.1.5.3.8.7 1 .2.1.4.1.7.1.5 0 .9-.2 1.1-.5.2-.3.4-.7.4-1.1 0-.5-.1-.9-.4-1.1-.3-.3-.7-.4-1.1-.4-.3 0-.6.1-.8.2-.2.1-.4.3-.6.5h-.8l.5-3.7h3.6v.8h-3l-.3 1.9c.2-.1.3-.2.5-.3.5-.1.8-.1 1.1-.1.6 0 1.2.2 1.6.6.4.4.7.9.7 1.6 0 .7-.2 1.2-.6 1.7-.4.5-1.1.8-1.9.8-.6 0-1.1-.2-1.5-.5-.4-.3-.7-.8-.7-1.5h.8z",
    fill: "#FFF"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BBB",
    d: "M12.2 0c6.2 0 11.3 4.6 12 10.5l1.9-2c.4-.4 1-.4 1.4 0 .2.2.3.4.3.7 0 .3-.1.5-.3.7l-3.8 3.7c-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.2l-4.1-3.5c0-.2-.2-.4-.2-.7 0-.3.1-.5.2-.7.4-.4 1-.5 1.4-.1l2.1 1.9C21 6 17 2.4 12.1 2.4c-5.4 0-9.7 4.3-9.7 9.6s4.3 9.6 9.7 9.6c2.4 0 4.6-.9 6.3-2.3.2-.3.5-.4.9-.4.7 0 1.2.5 1.2 1.2 0 .3-.1.5-.2.7l-.1.1-.1.1c-2.1 1.9-5 3.1-8.1 3.1C5.5 24 .1 18.6.1 12S5.5 0 12.2 0z"
  }));
});
// CONCATENATED MODULE: ./src/js/controls/quick-forward-button/quick-forward-button.js
function quick_forward_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { quick_forward_button_typeof = function _typeof(obj) { return typeof obj; }; } else { quick_forward_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return quick_forward_button_typeof(obj); }

function quick_forward_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function quick_forward_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function quick_forward_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) quick_forward_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) quick_forward_button_defineProperties(Constructor, staticProps); return Constructor; }

function quick_forward_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) quick_forward_button_setPrototypeOf(subClass, superClass); }

function quick_forward_button_setPrototypeOf(o, p) { quick_forward_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return quick_forward_button_setPrototypeOf(o, p); }

function quick_forward_button_createSuper(Derived) { var hasNativeReflectConstruct = quick_forward_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = quick_forward_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = quick_forward_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return quick_forward_button_possibleConstructorReturn(this, result); }; }

function quick_forward_button_possibleConstructorReturn(self, call) { if (call && (quick_forward_button_typeof(call) === "object" || typeof call === "function")) { return call; } return quick_forward_button_assertThisInitialized(self); }

function quick_forward_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function quick_forward_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function quick_forward_button_getPrototypeOf(o) { quick_forward_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return quick_forward_button_getPrototypeOf(o); }

function quick_forward_button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 *
 * QuickForwardButton fast-forward a certain value
 * ```js
 * <QuickForwardButton
 *     mediaPlayer={mediaPlayer}
 *     isEnabled={true}
 *     rewindValue={15}
 *     currentTime={currentTime}
 *     />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.quickForwardButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @module QuickForwardButton
 * @component QuickForwardButton
 *
 */

var quick_forward_button_QuickForwardButton = /*#__PURE__*/function (_Component) {
  quick_forward_button_inherits(QuickForwardButton, _Component);

  var _super = quick_forward_button_createSuper(QuickForwardButton);

  function QuickForwardButton() {
    var _this;

    quick_forward_button_classCallCheck(this, QuickForwardButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    quick_forward_button_defineProperty(quick_forward_button_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          forwardValue = _this$props.forwardValue,
          mediaPlayer = _this$props.mediaPlayer,
          currentTime = _this$props.currentTime;
      mediaPlayer.seek(currentTime + forwardValue);
    });

    return _this;
  }

  quick_forward_button_createClass(QuickForwardButton, [{
    key: "render",
    value:
    /**
     *
     * @desc render the quickforward component
     *
     */
    function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          forwardValue = _this$props2.forwardValue,
          currentTime = _this$props2.currentTime,
          duration = _this$props2.duration,
          isMinimumDuration = _this$props2.isMinimumDuration;
      var label = "Forward ".concat(forwardValue, " seconds");
      var classes = classnames_default()(quick_forward_button_defineProperty({
        'media-control-quick-forward': true,
        'media-control-disable': currentTime + forwardValue >= duration ? true : false
      }, "media-control-disable", !isMinimumDuration));
      return isEnabled ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: label,
        className: classes
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(quick_forward_icon, null)) : null;
    }
  }]);

  return QuickForwardButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

quick_forward_button_QuickForwardButton.componentId = 'quickForwardButton';
quick_forward_button_QuickForwardButton.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  isEnabled: prop_types_default.a.bool,
  forwardValue: prop_types_default.a.number,
  duration: prop_types_default.a.number
};
quick_forward_button_QuickForwardButton.defaultProps = {
  mediaPlayer: undefined,
  isEnabled: false,
  forwardValue: 15,
  duration: 0
};
/* harmony default export */ var quick_forward_button_quick_forward_button = (quick_forward_button_QuickForwardButton);
// CONCATENATED MODULE: ./src/js/controls/quick-forward-button/index.js





/* harmony default export */ var controls_quick_forward_button = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(quick_forward_button_quick_forward_button));
// EXTERNAL MODULE: ./src/js/controls/quick-rewind-button/quick-rewind-button.less
var quick_rewind_button = __webpack_require__(95);

// CONCATENATED MODULE: ./src/images/icons/quick-rewind-icon.svg
function quick_rewind_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = quick_rewind_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function quick_rewind_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function quick_rewind_icon_extends() {
  quick_rewind_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return quick_rewind_icon_extends.apply(this, arguments);
}


/* harmony default export */ var quick_rewind_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = quick_rewind_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", quick_rewind_icon_extends({
    version: "1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "28",
    height: "24"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M11.7 11.6v-.7c.6-.1 1.1-.2 1.3-.3.2-.1.4-.5.6-1h.7v6.9h-.9v-4.9h-1.7zm5.3 3.1c.1.5.3.8.7 1 .2.1.4.1.7.1.5 0 .9-.2 1.1-.5.2-.3.4-.7.4-1.1 0-.5-.1-.9-.4-1.1-.3-.3-.7-.4-1.1-.4-.3 0-.6.1-.8.2-.2.1-.4.3-.6.5h-.8l.5-3.7h3.6v.8h-3l-.3 1.9c.2-.1.3-.2.5-.3.5-.1.8-.1 1.1-.1.6 0 1.2.2 1.6.6.4.4.7.9.7 1.6 0 .7-.2 1.2-.6 1.7-.4.5-1.1.8-1.9.8-.6 0-1.1-.2-1.5-.5-.4-.3-.7-.8-.7-1.5h.8z",
    fill: "#FFF"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#BBB",
    d: "M15.8 0C9.6 0 4.5 4.6 3.7 10.5l-1.9-2c-.4-.4-1-.4-1.4 0-.2.2-.3.5-.3.8 0 .3.1.5.3.7l3.8 3.7c.1.2.4.3.7.3.2 0 .5-.1.7-.2l4.1-3.5c.1-.3.3-.5.3-.8 0-.2-.1-.5-.3-.7-.4-.4-1-.5-1.4-.1l-2.1 1.9c.7-4.6 4.7-8.2 9.6-8.2 5.4 0 9.7 4.3 9.7 9.6s-4.3 9.6-9.7 9.6c-2.4 0-4.6-.9-6.3-2.3-.2-.3-.5-.4-.9-.4-.7 0-1.2.5-1.2 1.2 0 .3.1.5.2.7l.1.1.1.1c2.1 1.9 5 3.1 8.1 3.1 6.7 0 12.1-5.4 12.1-12C27.9 5.4 22.5 0 15.8 0z"
  }));
});
// CONCATENATED MODULE: ./src/js/controls/quick-rewind-button/quick-rewind-button.js
function quick_rewind_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { quick_rewind_button_typeof = function _typeof(obj) { return typeof obj; }; } else { quick_rewind_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return quick_rewind_button_typeof(obj); }

function quick_rewind_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function quick_rewind_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function quick_rewind_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) quick_rewind_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) quick_rewind_button_defineProperties(Constructor, staticProps); return Constructor; }

function quick_rewind_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) quick_rewind_button_setPrototypeOf(subClass, superClass); }

function quick_rewind_button_setPrototypeOf(o, p) { quick_rewind_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return quick_rewind_button_setPrototypeOf(o, p); }

function quick_rewind_button_createSuper(Derived) { var hasNativeReflectConstruct = quick_rewind_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = quick_rewind_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = quick_rewind_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return quick_rewind_button_possibleConstructorReturn(this, result); }; }

function quick_rewind_button_possibleConstructorReturn(self, call) { if (call && (quick_rewind_button_typeof(call) === "object" || typeof call === "function")) { return call; } return quick_rewind_button_assertThisInitialized(self); }

function quick_rewind_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function quick_rewind_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function quick_rewind_button_getPrototypeOf(o) { quick_rewind_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return quick_rewind_button_getPrototypeOf(o); }

function quick_rewind_button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 *
 * QuickRewindButton button rewind a certain value
 * ```js
 * <QuickRewindButton
 *     mediaPlayer={mediaPlayer}
 *     isEnabled={true}
 *     rewindValue={15}
 *     currentTime={currentTime}
 *     />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.quickrewindButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @module QuickRewindButton
 * @component QuickRewindButton
 *
 */

var quick_rewind_button_QuickRewindButton = /*#__PURE__*/function (_Component) {
  quick_rewind_button_inherits(QuickRewindButton, _Component);

  var _super = quick_rewind_button_createSuper(QuickRewindButton);

  function QuickRewindButton() {
    var _this;

    quick_rewind_button_classCallCheck(this, QuickRewindButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    quick_rewind_button_defineProperty(quick_rewind_button_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          rewindValue = _this$props.rewindValue,
          mediaPlayer = _this$props.mediaPlayer,
          currentTime = _this$props.currentTime;
      mediaPlayer.seek(currentTime - rewindValue);
    });

    return _this;
  }

  quick_rewind_button_createClass(QuickRewindButton, [{
    key: "render",
    value:
    /**
     *
     * @desc render the quickrewind component
     *
     */
    function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          rewindValue = _this$props2.rewindValue,
          currentTime = _this$props2.currentTime,
          isMinimumDuration = _this$props2.isMinimumDuration;
      var label = "Back ".concat(rewindValue, " seconds");
      var classes = classnames_default()(quick_rewind_button_defineProperty({
        'media-control-quick-rewind': true,
        'media-control-disable': currentTime - rewindValue < 0 ? true : false
      }, "media-control-disable", !isMinimumDuration));
      return isEnabled ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: label,
        className: classes
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(quick_rewind_icon, null)) : null;
    }
  }]);

  return QuickRewindButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

quick_rewind_button_QuickRewindButton.componentId = 'quickRewindButton';
quick_rewind_button_QuickRewindButton.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  isEnabled: prop_types_default.a.bool,
  rewindValue: prop_types_default.a.number,
  currentTime: prop_types_default.a.number
};
quick_rewind_button_QuickRewindButton.defaultProps = {
  mediaPlayer: undefined,
  isEnabled: false,
  rewindValue: 15,
  currentTime: 0
};
/* harmony default export */ var quick_rewind_button_quick_rewind_button = (quick_rewind_button_QuickRewindButton);
// CONCATENATED MODULE: ./src/js/controls/quick-rewind-button/index.js





/* harmony default export */ var controls_quick_rewind_button = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(quick_rewind_button_quick_rewind_button));
// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/lodash/throttle.js
var throttle = __webpack_require__(97);

// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/rangeslider/lib/index.js
var lib = __webpack_require__(28);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/js/controls/slider/slider.less
var slider = __webpack_require__(104);

// CONCATENATED MODULE: ./src/js/controls/slider/slider.js
function slider_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { slider_typeof = function _typeof(obj) { return typeof obj; }; } else { slider_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return slider_typeof(obj); }

function slider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function slider_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function slider_createClass(Constructor, protoProps, staticProps) { if (protoProps) slider_defineProperties(Constructor.prototype, protoProps); if (staticProps) slider_defineProperties(Constructor, staticProps); return Constructor; }

function slider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) slider_setPrototypeOf(subClass, superClass); }

function slider_setPrototypeOf(o, p) { slider_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return slider_setPrototypeOf(o, p); }

function slider_createSuper(Derived) { var hasNativeReflectConstruct = slider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = slider_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = slider_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return slider_possibleConstructorReturn(this, result); }; }

function slider_possibleConstructorReturn(self, call) { if (call && (slider_typeof(call) === "object" || typeof call === "function")) { return call; } return slider_assertThisInitialized(self); }

function slider_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function slider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function slider_getPrototypeOf(o) { slider_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return slider_getPrototypeOf(o); }

function slider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var slider_Slider = /*#__PURE__*/function (_Component) {
  slider_inherits(Slider, _Component);

  var _super = slider_createSuper(Slider);

  function Slider(props) {
    var _this;

    slider_classCallCheck(this, Slider);

    _this = _super.call(this, props);

    slider_defineProperty(slider_assertThisInitialized(_this), "onChangeStart", function () {
      var onChangeStart = _this.props.onChangeStart;

      _this.setState({
        ignoreUpdates: true
      });

      if (onChangeStart) {
        onChangeStart();
      }
    });

    slider_defineProperty(slider_assertThisInitialized(_this), "onSliderChange", function (currentValue) {
      var onValueChanging = _this.props.onValueChanging;

      _this.setState({
        ignoreUpdates: true,
        currentValue: currentValue
      });

      if (onValueChanging) {
        onValueChanging(currentValue);
      }
    });

    slider_defineProperty(slider_assertThisInitialized(_this), "onChangeComplete", function () {
      var currentValue = _this.state.currentValue;
      var onAfterChange = _this.props.onAfterChange;

      _this.setState({
        ignoreUpdates: false
      });

      if (onAfterChange) {
        onAfterChange(currentValue);
      }
    });

    _this.state = {
      currentValue: props.value,
      ignoreUpdates: false
    };
    return _this;
  }

  slider_createClass(Slider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          ariaLabel = _this$props.ariaLabel,
          ariaValueText = _this$props.ariaValueText,
          ariaMin = _this$props.ariaMin,
          ariaNow = _this$props.ariaNow,
          ariaMax = _this$props.ariaMax,
          className = _this$props.className;
      var currentValue = this.state.currentValue;
      return max > 0 ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(lib_default.a, {
        className: className,
        tabIndex: 0,
        min: min,
        max: max,
        value: currentValue,
        step: step,
        tooltip: false,
        ariaLabel: ariaLabel,
        ariaValueText: ariaValueText,
        ariaMin: ariaMin,
        ariaNow: ariaNow,
        ariaMax: ariaMax,
        onChangeStart: this.onChangeStart,
        onChange: this.onSliderChange,
        onChangeComplete: this.onChangeComplete
      }) : null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!state.ignoreUpdates) {
        return {
          currentValue: props.value
        };
      }

      return null;
    }
  }]);

  return Slider;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

slider_Slider.propTypes = {
  /** The minimum value for the slider */
  min: prop_types_default.a.number,

  /** The maximum value for the slider */
  max: prop_types_default.a.number,

  /** The step between values */
  step: prop_types_default.a.number,

  /** ARIA label for the slider */
  ariaLabel: prop_types_default.a.string,

  /** AIRA text label value */
  ariaValueText: prop_types_default.a.string,

  /** ARIA min label value */
  ariaMin: prop_types_default.a.any,

  /** ARIA now label value */
  ariaNow: prop_types_default.a.any,

  /** ARIA max label value */
  ariaMax: prop_types_default.a.any,

  /** Callback executed when onChangeStart occurs on the slider */
  onChangeStart: prop_types_default.a.func,

  /** Callback executed when onSliderChange occurs on the slider */
  onSliderChange: prop_types_default.a.func,

  /** Callback executed when onChangeComplete occurs on the slider */
  onChangeComplete: prop_types_default.a.func
};
slider_Slider.defaultProps = {
  min: 0,
  max: 0,
  step: 0.3,
  ariaLabel: '',
  ariaValueText: '',
  ariaMin: 0,
  ariaNow: 0,
  ariaMax: 100,
  onChangeStart: function onChangeStart() {},
  onSliderChange: function onSliderChange() {},
  onChangeComplete: function onChangeComplete() {}
};
/* harmony default export */ var slider_slider = (slider_Slider);
// CONCATENATED MODULE: ./src/js/controls/slider/index.js

/* harmony default export */ var controls_slider = (slider_slider);
// CONCATENATED MODULE: ./src/js/util/time-util.js
function time_util_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function time_util_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function time_util_createClass(Constructor, protoProps, staticProps) { if (protoProps) time_util_defineProperties(Constructor.prototype, protoProps); if (staticProps) time_util_defineProperties(Constructor, staticProps); return Constructor; }

/**
 *
 * @class TimeUtil
 * @desc Utility object for working with time
 * @module TimeUtil
 *
 */
var TimeUtil = /*#__PURE__*/function () {
  function TimeUtil() {
    time_util_classCallCheck(this, TimeUtil);
  }

  time_util_createClass(TimeUtil, null, [{
    key: "padZero",
    value: function padZero(num) {
      var padNum = num;

      if (num < 10) {
        padNum = "0" + num;
      }

      return padNum;
    }
  }, {
    key: "formatSecondsToTimeCode",
    value: function formatSecondsToTimeCode(value) {
      var secondsNum = parseInt(value, 10) || 0;
      var hours = Math.floor(secondsNum / 3600);
      var minutes = Math.floor((secondsNum - hours * 3600) / 60);
      var seconds = secondsNum - hours * 3600 - minutes * 60;
      var timecode = '00:00:00';

      if (isNaN(value)) {
        return timecode;
      }

      if (hours > 0) {
        minutes = TimeUtil.padZero(minutes);
      }

      seconds = TimeUtil.padZero(seconds);
      hours > 0 ? timecode = "".concat(hours, ":").concat(minutes, ":").concat(seconds) : timecode = "".concat(minutes, ":").concat(seconds);
      return timecode;
    }
  }]);

  return TimeUtil;
}();

/* harmony default export */ var time_util = (TimeUtil);
// EXTERNAL MODULE: ./src/js/controls/scrubber-bar/scrubber-bar.less
var scrubber_bar = __webpack_require__(106);

// CONCATENATED MODULE: ./src/js/controls/scrubber-bar/scrubber-bar.js
function scrubber_bar_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { scrubber_bar_typeof = function _typeof(obj) { return typeof obj; }; } else { scrubber_bar_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return scrubber_bar_typeof(obj); }

function scrubber_bar_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function scrubber_bar_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function scrubber_bar_createClass(Constructor, protoProps, staticProps) { if (protoProps) scrubber_bar_defineProperties(Constructor.prototype, protoProps); if (staticProps) scrubber_bar_defineProperties(Constructor, staticProps); return Constructor; }

function scrubber_bar_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) scrubber_bar_setPrototypeOf(subClass, superClass); }

function scrubber_bar_setPrototypeOf(o, p) { scrubber_bar_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return scrubber_bar_setPrototypeOf(o, p); }

function scrubber_bar_createSuper(Derived) { var hasNativeReflectConstruct = scrubber_bar_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = scrubber_bar_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = scrubber_bar_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return scrubber_bar_possibleConstructorReturn(this, result); }; }

function scrubber_bar_possibleConstructorReturn(self, call) { if (call && (scrubber_bar_typeof(call) === "object" || typeof call === "function")) { return call; } return scrubber_bar_assertThisInitialized(self); }

function scrubber_bar_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function scrubber_bar_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function scrubber_bar_getPrototypeOf(o) { scrubber_bar_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return scrubber_bar_getPrototypeOf(o); }

function scrubber_bar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








/**
 *
 * Displays the video timeline and allows to seek through it
 * ```js
 * <ScrubberBar
 *     mediaPlayer={mediaPlayer}
 *     duration={videoDuration}
 *     currentTime={currentTime}
 *     seeking={seeking}
 *     buffer={currentBuffer}
 *     isLive={isLive}
 *     isAtLivePoint={isAtLivePoint} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.scrubberBar = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component ScrubberBar
 * @module ScrubberBar
 *
 */

var scrubber_bar_ScrubberBar = /*#__PURE__*/function (_Component) {
  scrubber_bar_inherits(ScrubberBar, _Component);

  var _super = scrubber_bar_createSuper(ScrubberBar);

  function ScrubberBar(props) {
    var _this;

    scrubber_bar_classCallCheck(this, ScrubberBar);

    _this = _super.call(this, props);

    scrubber_bar_defineProperty(scrubber_bar_assertThisInitialized(_this), "onChangeStart", function () {
      var mediaPlayer = _this.props.mediaPlayer;
      var wasPlaying = mediaPlayer.player.stateModel.playing;

      if (wasPlaying) {
        mediaPlayer.player.pause();
      }

      _this.setState({
        isSeeking: true,
        wasPlaying: wasPlaying
      });
    });

    scrubber_bar_defineProperty(scrubber_bar_assertThisInitialized(_this), "onSliderChange", function (currentValue) {
      var _this$props = _this.props,
          mediaPlayer = _this$props.mediaPlayer,
          duration = _this$props.duration;
      var selectedSeekTime = ScrubberBar.getTimeFromPercent(duration, currentValue);

      _this.setState({
        isSeeking: true,
        selectedSeekTime: selectedSeekTime
      });

      mediaPlayer.player.seek(selectedSeekTime);
    });

    scrubber_bar_defineProperty(scrubber_bar_assertThisInitialized(_this), "onAfterChange", function (selectedPercent) {
      var _this$props2 = _this.props,
          isMinimumDuration = _this$props2.isMinimumDuration,
          mediaPlayer = _this$props2.mediaPlayer,
          duration = _this$props2.duration;
      var wasPlaying = _this.state.wasPlaying;
      var seekToTime = ScrubberBar.getTimeFromPercent(duration, selectedPercent); // Don't seek if we we don't have a minimum duration

      if (!isMinimumDuration) {
        return;
      }

      _this.setState({
        isSeeking: true,
        selectedSeekTime: seekToTime
      });

      console.log('onAfterChange() - seek to', seekToTime);
      mediaPlayer.seek(seekToTime);

      if (wasPlaying) {
        mediaPlayer.play();
      }
    });

    _this.state = {
      isSeeking: false,
      currentTime: 0,
      selectedSeekTime: undefined
    };
    return _this;
  }

  scrubber_bar_createClass(ScrubberBar, [{
    key: "render",
    value:
    /**
     *
     * @desc Render the current time
     *
     */
    function render() {
      var _this$props3 = this.props,
          duration = _this$props3.duration,
          isLive = _this$props3.isLive,
          isAtLivePoint = _this$props3.isAtLivePoint,
          isMinimumDuration = _this$props3.isMinimumDuration;
      var _this$state = this.state,
          isSeeking = _this$state.isSeeking,
          currentTime = _this$state.currentTime,
          selectedSeekTime = _this$state.selectedSeekTime;
      var time = ScrubberBar.getCurrentTimeToUse(currentTime, duration, isSeeking, isLive, isAtLivePoint, selectedSeekTime);
      var percent = time / duration * ScrubberBar.SEEK_MULTIPLIER;
      var currentTimecode = time_util.formatSecondsToTimeCode(time);
      var durationTimecode = time_util.formatSecondsToTimeCode(duration);
      var classes = classnames_default()({
        'media-control-disable': !isMinimumDuration
      });
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "scrubber-bar-wrapper"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_slider, {
        className: classes,
        value: percent,
        min: 0,
        max: ScrubberBar.SEEK_MULTIPLIER,
        step: 0.02,
        ariaLabel: "Seek slider",
        ariaValueText: "".concat(currentTimecode, " of ").concat(durationTimecode),
        ariaMin: 0,
        ariaNow: Math.round(time),
        ariaMax: Math.round(duration),
        onChangeStart: this.onChangeStart,
        onValueChanging: this.onSliderChange,
        onAfterChange: this.onAfterChange
      }));
    }
  }], [{
    key: "getCurrentTimeToUse",
    value: function getCurrentTimeToUse(currentTime, endTime, isSeeking, isLive, isAtLivePoint, selectedSeekTime) {
      var currentTimeToUse = currentTime;

      if (isSeeking) {
        return selectedSeekTime;
      } else if (!isSeeking && isLive && isAtLivePoint) {
        return endTime;
      }

      return currentTimeToUse;
    }
  }, {
    key: "getTimeFromPercent",
    value: function getTimeFromPercent(duration, percent) {
      var time = duration * (percent / ScrubberBar.SEEK_MULTIPLIER);
      return time;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var currentTime = props.currentTime,
          seeking = props.seeking;

      if (state.isSeeking) {
        return {
          currentTime: state.selectedSeekTime,
          isSeeking: seeking
        };
      } else {
        return {
          currentTime: currentTime,
          isSeeking: seeking,
          selectedSeekTime: undefined
        };
      }
    }
  }]);

  return ScrubberBar;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

scrubber_bar_ScrubberBar.SEEK_MULTIPLIER = 5000;
scrubber_bar_ScrubberBar.componentId = 'scrubberBar';
scrubber_bar_ScrubberBar.propTypes = {
  /** The media player instance */
  mediaPlayer: prop_types_default.a.object,

  /** Start time of the media */
  startTime: prop_types_default.a.number,

  /** End time of the media */
  endTime: prop_types_default.a.number,

  /** Duration of the media */
  duration: prop_types_default.a.number,

  /** Current time of the media */
  currentTime: prop_types_default.a.number,

  /** If the player is seeking or not */
  seeking: prop_types_default.a.bool,

  /** If the media is live or not */
  isLive: prop_types_default.a.bool,

  /** If the player is at the live point or not */
  isAtLivePoint: prop_types_default.a.bool
};
scrubber_bar_ScrubberBar.defaultProps = {
  mediaPlayer: undefined,
  startTime: 0,
  endTime: 0,
  duration: 0,
  currentTime: 0,
  seeking: false,
  isLive: false,
  isAtLivePoint: false
};
/* harmony default export */ var scrubber_bar_scrubber_bar = (scrubber_bar_ScrubberBar);
// CONCATENATED MODULE: ./src/js/controls/scrubber-bar/index.js




/* harmony default export */ var controls_scrubber_bar = (dist_default()(with_config_hoc(), with_focus_hoc({
  usesArrowKeys: true
}))(scrubber_bar_scrubber_bar));
// EXTERNAL MODULE: ./src/js/controls/time-display/timecode-display.less
var timecode_display = __webpack_require__(108);

// CONCATENATED MODULE: ./src/js/controls/time-display/timecode-display.js
function timecode_display_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { timecode_display_typeof = function _typeof(obj) { return typeof obj; }; } else { timecode_display_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return timecode_display_typeof(obj); }

function timecode_display_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function timecode_display_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function timecode_display_createClass(Constructor, protoProps, staticProps) { if (protoProps) timecode_display_defineProperties(Constructor.prototype, protoProps); if (staticProps) timecode_display_defineProperties(Constructor, staticProps); return Constructor; }

function timecode_display_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) timecode_display_setPrototypeOf(subClass, superClass); }

function timecode_display_setPrototypeOf(o, p) { timecode_display_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return timecode_display_setPrototypeOf(o, p); }

function timecode_display_createSuper(Derived) { var hasNativeReflectConstruct = timecode_display_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = timecode_display_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = timecode_display_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return timecode_display_possibleConstructorReturn(this, result); }; }

function timecode_display_possibleConstructorReturn(self, call) { if (call && (timecode_display_typeof(call) === "object" || typeof call === "function")) { return call; } return timecode_display_assertThisInitialized(self); }

function timecode_display_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function timecode_display_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function timecode_display_getPrototypeOf(o) { timecode_display_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return timecode_display_getPrototypeOf(o); }



var DEFAULT_TIMECODE = '00:00:00';
/**
 *
 * Displays the current time
 * ```js
 * <TimecodeDisplay
 *     mediaPlayer={mediaPlayer}
 *     timecode={durationTimecode}
 *     ariaLabel={`Duration: ${durationTimecode}`}
 *     enabled={!isLive}
 *     className="media-control-duration"/>
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.timecodeDisplay = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @module TimecodeDisplay
 * @component TimecodeDisplay
 *
 */

var timecode_display_TimecodeDisplay = /*#__PURE__*/function (_Component) {
  timecode_display_inherits(TimecodeDisplay, _Component);

  var _super = timecode_display_createSuper(TimecodeDisplay);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function TimecodeDisplay(props) {
    timecode_display_classCallCheck(this, TimecodeDisplay);

    return _super.call(this, props);
  }

  timecode_display_createClass(TimecodeDisplay, [{
    key: "getClassNames",
    value: function getClassNames(enabled) {
      var classNames = "media-control media-control--timecode-display ".concat(this.props.className, " ").concat(enabled ? '' : 'disabled');
      return classNames;
    }
    /**
     *
     * @desc Render the current time
     *
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          enabled = _this$props.enabled,
          timecode = _this$props.timecode,
          ariaLabel = _this$props.ariaLabel;

      if (!enabled) {
        timecode = DEFAULT_TIMECODE;
        ariaLabel = DEFAULT_TIMECODE;
      }

      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("p", {
        className: this.getClassNames(enabled),
        tabIndex: -1,
        "aria-label": ariaLabel
      }, timecode);
    }
  }]);

  return TimecodeDisplay;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

timecode_display_TimecodeDisplay.componentId = 'timecodeDisplay';
timecode_display_TimecodeDisplay.propTypes = {
  className: prop_types_default.a.string,
  enabled: prop_types_default.a.bool,
  timecode: prop_types_default.a.string.isRequired,
  ariaLabel: prop_types_default.a.string
};
timecode_display_TimecodeDisplay.defaultProps = {
  className: '',
  enabled: true,
  timecode: DEFAULT_TIMECODE,
  ariaLabel: ''
};
/* harmony default export */ var time_display_timecode_display = (timecode_display_TimecodeDisplay);
// CONCATENATED MODULE: ./src/js/controls/time-display/index.js



/* harmony default export */ var time_display = (with_config_hoc()(time_display_timecode_display));
// EXTERNAL MODULE: ./src/js/controls/volume/mute-button/mute-button.less
var mute_button = __webpack_require__(110);

// CONCATENATED MODULE: ./src/images/icons/mute-icon.svg
function mute_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = mute_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function mute_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function mute_icon_extends() {
  mute_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return mute_icon_extends.apply(this, arguments);
}


/* harmony default export */ var mute_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = mute_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", mute_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "24",
    version: "1.0"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    opacity: ".5"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M11.6 3.3L6.4 7.6H1.8c-1 0-1.8.7-1.8 1.5V15c0 .8.8 1.5 1.8 1.5h4.7l5.2 4.4c.3.2.5.1.5-.2V3.5c-.1-.3-.3-.4-.6-.2zm16-2.9c-.4-.5-1.2-.6-1.7-.2-.3.2-.4.5-.4.8 0 .3.1.6.3.9 5.1 6 5.1 14 0 20-.2.3-.3.6-.3.9 0 .3.2.6.4.8.2.2.5.3.8.3.4 0 .7-.2 1-.4 5.8-6.9 5.8-16.1-.1-23.1z"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M22.3 3.4c-.4-.5-1.2-.6-1.7-.1-.3.2-.4.5-.4.8 0 .3.1.6.3.9 3.6 4.1 3.6 9.9 0 14-.2.3-.3.6-.3.9s.2.6.4.8c.2.2.5.3.8.3.4 0 .7-.2.9-.4 4.3-5.1 4.3-12.1 0-17.2zm-7.1 2.9c-.3.2-.4.5-.4.8 0 .3.1.6.3.9 2.1 2.3 2.1 5.6 0 7.9-.2.2-.3.6-.3.9 0 .3.2.6.4.8.2.2.5.3.8.3.4 0 .7-.2.9-.4 2.9-3.3 2.9-7.9 0-11.2-.4-.4-1.2-.4-1.7 0z"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M4.3.5c.6-.6 1.5-.6 2 0l21.1 21c.6.6.6 1.5 0 2-.6.6-1.5.6-2 0L4.3 2.5c-.5-.6-.5-1.5 0-2z"
  })));
});
// CONCATENATED MODULE: ./src/images/icons/unmute-icon.svg
function unmute_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = unmute_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function unmute_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function unmute_icon_extends() {
  unmute_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return unmute_icon_extends.apply(this, arguments);
}


/* harmony default export */ var unmute_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = unmute_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", unmute_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "24",
    version: "1.0"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("g", {
    opacity: ".5",
    fill: "#FFF"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M11.6 3.3L6.4 7.6H1.8c-1 0-1.8.7-1.8 1.5V15c0 .8.8 1.5 1.8 1.5h4.7l5.2 4.4c.3.2.5.1.5-.2V3.5c-.1-.3-.3-.4-.6-.2zm16-2.9c-.4-.5-1.2-.6-1.7-.2-.3.2-.4.5-.4.8 0 .3.1.6.3.9 5.1 6 5.1 14 0 20-.2.3-.3.6-.3.9 0 .3.2.6.4.8.2.2.5.3.8.3.4 0 .7-.2 1-.4 5.8-6.9 5.8-16.1-.1-23.1z"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M22.3 3.4c-.4-.5-1.2-.6-1.7-.1-.3.2-.4.5-.4.8 0 .3.1.6.3.9 3.6 4.1 3.6 9.9 0 14-.2.3-.3.6-.3.9s.2.6.4.8c.2.2.5.3.8.3.4 0 .7-.2.9-.4 4.3-5.1 4.3-12.1 0-17.2zm-7.1 2.9c-.3.2-.4.5-.4.8 0 .3.1.6.3.9 2.1 2.3 2.1 5.6 0 7.9-.2.2-.3.6-.3.9 0 .3.2.6.4.8.2.2.5.3.8.3.4 0 .7-.2.9-.4 2.9-3.3 2.9-7.9 0-11.2-.4-.4-1.2-.4-1.7 0z"
  })));
});
// CONCATENATED MODULE: ./src/js/controls/volume/mute-button/mute-button.js
function mute_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { mute_button_typeof = function _typeof(obj) { return typeof obj; }; } else { mute_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return mute_button_typeof(obj); }

function mute_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mute_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function mute_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) mute_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) mute_button_defineProperties(Constructor, staticProps); return Constructor; }

function mute_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) mute_button_setPrototypeOf(subClass, superClass); }

function mute_button_setPrototypeOf(o, p) { mute_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return mute_button_setPrototypeOf(o, p); }

function mute_button_createSuper(Derived) { var hasNativeReflectConstruct = mute_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = mute_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = mute_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return mute_button_possibleConstructorReturn(this, result); }; }

function mute_button_possibleConstructorReturn(self, call) { if (call && (mute_button_typeof(call) === "object" || typeof call === "function")) { return call; } return mute_button_assertThisInitialized(self); }

function mute_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function mute_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function mute_button_getPrototypeOf(o) { mute_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return mute_button_getPrototypeOf(o); }






/**
 *
 * Mute button to toggle mute and un-mute
 * ```js
 * <MuteButton
 *     mediaPlayer={mediaPlayer}
 *     volume={volume} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.muteButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @module MuteButton
 * @component MuteButton
 *
 */

var mute_button_MuteButton = /*#__PURE__*/function (_Component) {
  mute_button_inherits(MuteButton, _Component);

  var _super = mute_button_createSuper(MuteButton);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function MuteButton(props) {
    var _this;

    mute_button_classCallCheck(this, MuteButton);

    _this = _super.call(this, props);
    _this.onClick = _this.onClick.bind(mute_button_assertThisInitialized(_this));
    return _this;
  }
  /**
   *
   * @desc Click handler. Calls .mute() on the player API
   *
   */


  mute_button_createClass(MuteButton, [{
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
          volume = _this$props.volume,
          mediaPlayer = _this$props.mediaPlayer;
      console.log('mute button onclick', mediaPlayer, this.props);

      if (volume.muted) {
        mediaPlayer.unMute();
        var newVolume = volume.lastValue <= 0.1 ? 0.7 : volume.lastValue;
        mediaPlayer.setVolume(newVolume);
      } else {
        mediaPlayer.mute();
      }
    }
    /**
     *
     * @desc Render the mute button
     *
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          muted = _this$props2.muted,
          volume = _this$props2.volume;
      muted = volume.value <= 0 ? true : volume.muted;
      var label = muted ? 'Un-mute (m)' : 'Mute (m)';
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: label,
        ariaPressed: muted,
        className: "media-control--mute"
      }, muted ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(mute_icon, null) : /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(unmute_icon, null));
    }
  }]);

  return MuteButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

mute_button_MuteButton.componentId = 'muteButton';
mute_button_MuteButton.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  mute: prop_types_default.a.bool,
  volume: prop_types_default.a.shape({
    volume: prop_types_default.a.number,
    muted: prop_types_default.a.bool,
    lastValue: prop_types_default.a.number
  })
};
mute_button_MuteButton.defaultProps = {
  mediaPlayer: undefined,
  mute: false,
  volume: {
    value: 0,
    muted: false,
    lastValue: 0
  }
};
/* harmony default export */ var mute_button_mute_button = (mute_button_MuteButton);
// CONCATENATED MODULE: ./src/js/controls/volume/mute-button/index.js





/* harmony default export */ var volume_mute_button = (dist_default()(with_config_hoc(), with_focus_hoc({
  isButton: true
}))(mute_button_mute_button));
// EXTERNAL MODULE: ./src/js/controls/volume/volume-slider/volume-slider.less
var volume_slider = __webpack_require__(112);

// CONCATENATED MODULE: ./src/js/controls/volume/volume-slider/volume-slider.js
function volume_slider_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { volume_slider_typeof = function _typeof(obj) { return typeof obj; }; } else { volume_slider_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return volume_slider_typeof(obj); }

function volume_slider_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function volume_slider_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function volume_slider_createClass(Constructor, protoProps, staticProps) { if (protoProps) volume_slider_defineProperties(Constructor.prototype, protoProps); if (staticProps) volume_slider_defineProperties(Constructor, staticProps); return Constructor; }

function volume_slider_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) volume_slider_setPrototypeOf(subClass, superClass); }

function volume_slider_setPrototypeOf(o, p) { volume_slider_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return volume_slider_setPrototypeOf(o, p); }

function volume_slider_createSuper(Derived) { var hasNativeReflectConstruct = volume_slider_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = volume_slider_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = volume_slider_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return volume_slider_possibleConstructorReturn(this, result); }; }

function volume_slider_possibleConstructorReturn(self, call) { if (call && (volume_slider_typeof(call) === "object" || typeof call === "function")) { return call; } return volume_slider_assertThisInitialized(self); }

function volume_slider_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function volume_slider_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function volume_slider_getPrototypeOf(o) { volume_slider_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return volume_slider_getPrototypeOf(o); }

function volume_slider_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 *
 * Volume bar with a knob, to change volume level
 * ```js
 * <VolumeSlider
 *     mediaPlayer={mediaPlayer}
 *     volume={volume} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.volumeSlider = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @module VolumeSlider
 * @component VolumeSlider
 *
 */

var volume_slider_VolumeSlider = /*#__PURE__*/function (_Component) {
  volume_slider_inherits(VolumeSlider, _Component);

  var _super = volume_slider_createSuper(VolumeSlider);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function VolumeSlider(props) {
    var _this;

    volume_slider_classCallCheck(this, VolumeSlider);

    _this = _super.call(this, props);

    volume_slider_defineProperty(volume_slider_assertThisInitialized(_this), "onValueChanging", function (currentValue) {
      var _this$props = _this.props,
          mediaPlayer = _this$props.mediaPlayer,
          volume = _this$props.volume;
      mediaPlayer.setVolume(currentValue / 100);

      if (currentValue > 0 && volume.muted) {
        mediaPlayer.unMute();
      } else if (currentValue <= 0 && !volume.muted) {
        mediaPlayer.mute();
      }
    });

    return _this;
  }

  volume_slider_createClass(VolumeSlider, [{
    key: "render",
    value:
    /**
     *
     * @desc Render the mute button
     *
     */
    function render() {
      var volume = this.props.volume;
      var mutedLabel = volume.muted ? 'Muted' : '';
      var volumePercent = volume.value * 100;
      var volumeValue = volume.muted ? 0 : volumePercent;
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "media-control-volume-slider"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_slider, {
        tabIndex: 0,
        min: 0,
        max: 100,
        value: volumeValue,
        ariaLabel: "",
        ariaValueText: "".concat(mutedLabel, " ").concat(Math.round(volumePercent), "% Volume"),
        ariaMin: "0",
        ariaNow: volumeValue,
        ariaMax: "100",
        step: 0.03,
        tooltip: false,
        onValueChanging: this.onValueChanging
      }));
    }
  }]);

  return VolumeSlider;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

volume_slider_VolumeSlider.componentId = 'volumeSlider';
volume_slider_VolumeSlider.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  volume: prop_types_default.a.shape({
    value: prop_types_default.a.number,
    muted: prop_types_default.a.bool,
    lastValue: prop_types_default.a.number
  })
};
volume_slider_VolumeSlider.defaultProps = {
  mediaPlayer: undefined,
  volume: {
    value: 0,
    muted: false,
    lastValue: 0
  }
};
/* harmony default export */ var volume_slider_volume_slider = (volume_slider_VolumeSlider);
// CONCATENATED MODULE: ./src/js/controls/volume/volume-slider/index.js





/* harmony default export */ var volume_volume_slider = (dist_default()(with_config_hoc(), with_focus_hoc({
  usesArrowKeys: true
}))(volume_slider_volume_slider));
// CONCATENATED MODULE: ./src/js/events/controls-events.js
/* harmony default export */ var controls_events = ({
  STOP: 'playerControlsStop'
});
// EXTERNAL MODULE: ./src/js/layouts/default-layout/default-layout.less
var default_layout = __webpack_require__(114);

// EXTERNAL MODULE: external {"commonjs":"mlb-media-player","commonjs2":"mlb-media-player","amd":"mlb-media-player","root":"MediaPlayer"}
var external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_ = __webpack_require__(18);

// CONCATENATED MODULE: ./src/js/controls/closed-captions/closed-captions.js
function closed_captions_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { closed_captions_typeof = function _typeof(obj) { return typeof obj; }; } else { closed_captions_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return closed_captions_typeof(obj); }

function closed_captions_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function closed_captions_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function closed_captions_createClass(Constructor, protoProps, staticProps) { if (protoProps) closed_captions_defineProperties(Constructor.prototype, protoProps); if (staticProps) closed_captions_defineProperties(Constructor, staticProps); return Constructor; }

function closed_captions_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) closed_captions_setPrototypeOf(subClass, superClass); }

function closed_captions_setPrototypeOf(o, p) { closed_captions_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return closed_captions_setPrototypeOf(o, p); }

function closed_captions_createSuper(Derived) { var hasNativeReflectConstruct = closed_captions_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = closed_captions_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = closed_captions_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return closed_captions_possibleConstructorReturn(this, result); }; }

function closed_captions_possibleConstructorReturn(self, call) { if (call && (closed_captions_typeof(call) === "object" || typeof call === "function")) { return call; } return closed_captions_assertThisInitialized(self); }

function closed_captions_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function closed_captions_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function closed_captions_getPrototypeOf(o) { closed_captions_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return closed_captions_getPrototypeOf(o); }

function closed_captions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 *
 * Closed captions/sub-title display component. Handles display of `track` elements.
 * ```js
 * <ClosedCaptions
 *  mediaPlayer={this.props.mediaPlayer}
 *  closedCaptionsActive={this.props.closedCaptionsActive} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.closedCaptions = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component ClosedCaptions
 * @module ClosedCaptions
 *
 */

var closed_captions_ClosedCaptions = /*#__PURE__*/function (_PureComponent) {
  closed_captions_inherits(ClosedCaptions, _PureComponent);

  var _super = closed_captions_createSuper(ClosedCaptions);

  function ClosedCaptions(props) {
    var _this;

    closed_captions_classCallCheck(this, ClosedCaptions);

    _this = _super.call(this, props);

    closed_captions_defineProperty(closed_captions_assertThisInitialized(_this), "pickClosedCaptions", function () {
      var self = closed_captions_assertThisInitialized(_this);

      var textTrack = _this.findBestTextTrack(_this.props.closedCaptions);

      if (textTrack) {
        textTrack.mode = 'hidden';
        Array.from(textTrack.cues).forEach(function (cue) {
          cue.onenter = function () {
            // In this context, 'this' is the VTTCue element
            self.cueEnter(this);
          };

          cue.onexit = function () {
            // In this context, 'this' is the VTTCue element
            self.cueExit(this);
          };
        });
      }
    });

    closed_captions_defineProperty(closed_captions_assertThisInitialized(_this), "clenupCueText", function (cueText) {
      return cueText.replace(/\<[^\>]+\>/gmi, '');
    });

    closed_captions_defineProperty(closed_captions_assertThisInitialized(_this), "cueEnter", function (cue) {
      _this.setState({
        currentCue: _this.clenupCueText(cue.text)
      });
    });

    closed_captions_defineProperty(closed_captions_assertThisInitialized(_this), "cueExit", function () {
      _this.setState({
        currentCue: ''
      });
    });

    _this.state = {
      currentCue: ''
    };
    _this.subscriptions = [];

    _this.subscribe();

    return _this;
  }

  closed_captions_createClass(ClosedCaptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.pickClosedCaptions();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unpickClosedCaptions();
      this.unsubscribe();
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
  }, {
    key: "findBestTextTrack",
    value: function findBestTextTrack(textTracks) {
      textTracks = textTracks || [];
      return Array.from(textTracks).sort(function (a, b) {
        var bothVttFiles = a.isVttFile && !b.isVttFile;

        if (bothVttFiles) {
          return 0;
        }

        return a.isVttFile && !b.isVttFile ? -1 : 1;
      })[0];
    }
  }, {
    key: "unpickClosedCaptions",
    value: function unpickClosedCaptions() {
      var textTrack = this.findBestTextTrack(this.props.closedCaptions);

      var noop = function noop() {};

      if (textTrack && textTrack.cues) {
        Array.from(textTrack.cues).forEach(function (cue) {
          cue.onenter = noop;
          cue.onexit = noop;
        });
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var observationCenter = this.props.mediaPlayer.observationCenter;
      var textTracksSubscription = observationCenter.playerSubject.pipe(Object(operators_["filter"])(function (message) {
        /**
         * SUBTITLE_FRAG_PROCESSED because HLS subtitles are updates as fragments are
         * loaded and processed. In versions >v0.14.0-beta.1 of hls.js there will
         * be a CUES_PARSED event that can be used instead
         */
        return message.type === external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"].HTML5.TEXT_TRACK_ENABLED || message.type === external_commonjs_mlb_media_player_commonjs2_mlb_media_player_amd_mlb_media_player_root_MediaPlayer_["MediaPlayerEvents"].HLSJS.SUBTITLE_FRAG_PROCESSED;
      })).subscribe(function () {
        _this2.pickClosedCaptions();
      });
      this.subscriptions.push(textTracksSubscription);
    }
  }, {
    key: "render",
    value: function render() {
      var closedCaptionsActive = this.props.closedCaptionsActive;
      var currentCue = this.state.currentCue;
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "closed-captions"
      }, closedCaptionsActive && currentCue ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "cue"
      }, currentCue) : null);
    }
  }]);

  return ClosedCaptions;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["PureComponent"]);

closed_captions_ClosedCaptions.componentId = 'closedCaptions';
closed_captions_ClosedCaptions.propTypes = {
  mediaPlayer: prop_types_default.a.object,
  closedCaptionsActive: prop_types_default.a.bool,
  closedCaptions: prop_types_default.a.object
};
closed_captions_ClosedCaptions.defaultProps = {
  mediaPlayer: undefined,
  closedCaptionsActive: false,
  closedCaptions: {}
};
/* harmony default export */ var closed_captions = (closed_captions_ClosedCaptions);
// EXTERNAL MODULE: ./src/js/controls/closed-captions/closed-captions.less
var closed_captions_closed_captions = __webpack_require__(116);

// CONCATENATED MODULE: ./src/js/controls/closed-captions/index.js



/* harmony default export */ var controls_closed_captions = (with_config_hoc()(closed_captions));
// EXTERNAL MODULE: ./src/js/controls/close-button/close-button.less
var close_button = __webpack_require__(118);

// CONCATENATED MODULE: ./src/images/icons/close-icon.svg
function close_icon_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = close_icon_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function close_icon_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function close_icon_extends() {
  close_icon_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return close_icon_extends.apply(this, arguments);
}


/* harmony default export */ var close_icon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = close_icon_objectWithoutProperties(_ref, ["styles"]);

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("svg", close_icon_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("path", {
    d: "M10.3 488.6c13.8 13.1 36.2 13.1 49.9 0l195.6-185.5 195.6 185.5c13.8 13.1 36.2 13.1 49.9 0 13.8-13.1 13.8-34.3 0-47.4L305.8 255.7 501.3 70.2c13.8-13.1 13.8-34.3 0-47.4-13.8-13.1-36.2-13.1-49.9 0L255.8 208.3 60.3 22.8c-13.8-13.1-36.2-13.1-49.9 0-13.8 13.1-13.8 34.3 0 47.4L206 255.7 10.3 441.2c-13.7 13.1-13.7 34.4 0 47.4z",
    className: styles["bust0"] || "bust0"
  }));
});
// CONCATENATED MODULE: ./src/js/controls/close-button/close-button.js
function close_button_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { close_button_typeof = function _typeof(obj) { return typeof obj; }; } else { close_button_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return close_button_typeof(obj); }

function close_button_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function close_button_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function close_button_createClass(Constructor, protoProps, staticProps) { if (protoProps) close_button_defineProperties(Constructor.prototype, protoProps); if (staticProps) close_button_defineProperties(Constructor, staticProps); return Constructor; }

function close_button_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) close_button_setPrototypeOf(subClass, superClass); }

function close_button_setPrototypeOf(o, p) { close_button_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return close_button_setPrototypeOf(o, p); }

function close_button_createSuper(Derived) { var hasNativeReflectConstruct = close_button_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = close_button_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = close_button_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return close_button_possibleConstructorReturn(this, result); }; }

function close_button_possibleConstructorReturn(self, call) { if (call && (close_button_typeof(call) === "object" || typeof call === "function")) { return call; } return close_button_assertThisInitialized(self); }

function close_button_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function close_button_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function close_button_getPrototypeOf(o) { close_button_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return close_button_getPrototypeOf(o); }

function close_button_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/**
 *
 * Button to enable/disable captions and sub-titles.
 * ```js
 * <CloseButton
 *  mediaPlayer={this.props.mediaPlayer}
 *  closedCaptionsActive={this.props.closedCaptionsActive}
 *  hasClosedCaptions={this.props.hasClosedCaptions} />
 * ```
 * Can be configured through mediaPlayer config
 * ```js
 * mediaPlayer.config.controlsConfig.closedCaptionsButton = {
 *     enabled: false, // defaults to true
 * };
 * ```
 * @component ClosedCaptionsButton
 * @module ClosedCaptionsButton
 *
 */

var close_button_CloseButton = /*#__PURE__*/function (_Component) {
  close_button_inherits(CloseButton, _Component);

  var _super = close_button_createSuper(CloseButton);

  function CloseButton(props) {
    var _this;

    close_button_classCallCheck(this, CloseButton);

    _this = _super.call(this, props);

    close_button_defineProperty(close_button_assertThisInitialized(_this), "onClick", function () {
      _this.props.mediaPlayer.stop();

      _this.controlsSubject.next({
        type: controls_events.STOP
      }, _this.props.mediaPlayer);
    });

    var mediaPlayer = _this.props.mediaPlayer;
    var observationCenter = mediaPlayer.observationCenter;
    _this.observationCenter = observationCenter;
    _this.controlsSubject = observationCenter.controlsSubject;
    return _this;
  }
  /**
   *
   * @desc onCLick handler. Toggle closed captions on/off.
   *
   */


  close_button_createClass(CloseButton, [{
    key: "render",
    value:
    /**
     *
     * @desc render the closed captions button
     *
     */
    function render() {
      var label = "Close player";
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: label,
        className: "close-button",
        ariaPressed: true
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(close_icon, null));
    }
  }]);

  return CloseButton;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

close_button_CloseButton.componentId = 'closeButton';
close_button_CloseButton.propTypes = {
  mediaPlayer: prop_types_default.a.object
};
close_button_CloseButton.defaultProps = {
  mediaPlayer: undefined
};
/* harmony default export */ var close_button_close_button = (close_button_CloseButton);
// CONCATENATED MODULE: ./src/js/controls/close-button/index.js





/* harmony default export */ var controls_close_button = (dist_default()(with_config_hoc({
  enabled: false
}), with_focus_hoc({
  isButton: true
}))(close_button_close_button));
// CONCATENATED MODULE: ./src/js/layouts/default-layout/default-layout.js
function default_layout_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { default_layout_typeof = function _typeof(obj) { return typeof obj; }; } else { default_layout_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return default_layout_typeof(obj); }

function default_layout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function default_layout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function default_layout_createClass(Constructor, protoProps, staticProps) { if (protoProps) default_layout_defineProperties(Constructor.prototype, protoProps); if (staticProps) default_layout_defineProperties(Constructor, staticProps); return Constructor; }

function default_layout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) default_layout_setPrototypeOf(subClass, superClass); }

function default_layout_setPrototypeOf(o, p) { default_layout_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return default_layout_setPrototypeOf(o, p); }

function default_layout_createSuper(Derived) { var hasNativeReflectConstruct = default_layout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = default_layout_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = default_layout_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return default_layout_possibleConstructorReturn(this, result); }; }

function default_layout_possibleConstructorReturn(self, call) { if (call && (default_layout_typeof(call) === "object" || typeof call === "function")) { return call; } return default_layout_assertThisInitialized(self); }

function default_layout_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function default_layout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function default_layout_getPrototypeOf(o) { default_layout_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return default_layout_getPrototypeOf(o); }

/**
 *
 * @class DefaultLayout
 * @desc The DefaultLayout container
 * @module DefaultLayout
 *
 */

















var default_layout_DefaultLayout = /*#__PURE__*/function (_Component) {
  default_layout_inherits(DefaultLayout, _Component);

  var _super = default_layout_createSuper(DefaultLayout);

  /**
   *
   * @constructor
   * @param {object} props
   *
   */
  function DefaultLayout(props) {
    default_layout_classCallCheck(this, DefaultLayout);

    return _super.call(this, props);
  }

  default_layout_createClass(DefaultLayout, [{
    key: "getBottomControlsContainerClassNames",
    value: function getBottomControlsContainerClassNames() {
      return classnames_default()({
        'bottom-controls-container': true,
        'controls-hidden': !this.props.controlsVisible
      });
    }
  }, {
    key: "getBottomControlsClassNames",
    value: function getBottomControlsClassNames() {
      return classnames_default()({
        'bottom-controls': true,
        'controls-hidden': !this.props.controlsVisible
      });
    }
  }, {
    key: "getTimeCodeDisplay",
    value: function getTimeCodeDisplay(mediaPlayer, isLive, currentTime, duration, seekableRange) {
      var durationToUse = isLive ? seekableRange.end - seekableRange.start : duration;
      var currentTimeToUse = isLive ? currentTime - seekableRange.start : currentTime;
      var currentTimecode = time_util.formatSecondsToTimeCode(currentTimeToUse);
      var durationTimecode = time_util.formatSecondsToTimeCode(durationToUse);
      var currentTimeFragment = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.Fragment, null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(time_display, {
        mediaPlayer: mediaPlayer,
        timecode: currentTimecode,
        ariaLabel: "Current time: ".concat(currentTimecode),
        className: "media-control-current-time"
      }));
      var durationFragment = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.Fragment, null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(time_display, {
        mediaPlayer: mediaPlayer,
        timecode: durationTimecode,
        ariaLabel: "Duration: ".concat(durationTimecode),
        enabled: !isLive,
        className: "media-control-duration"
      }));

      if (isLive) {
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.Fragment, null, durationFragment, currentTimeFragment);
      } else {
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.Fragment, null, currentTimeFragment, durationFragment);
      }
    }
    /**
     *
     * @desc Render the controls
     *
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mediaPlayer = _this$props.mediaPlayer,
          fullscreenElement = _this$props.fullscreenElement,
          playerState = _this$props.playerState,
          playerTimeState = _this$props.playerTimeState;
      var paused = playerState.paused,
          volume = playerState.volume,
          isFullscreen = playerState.isFullscreen,
          isFullscreenEnabled = playerState.isFullscreenEnabled,
          _playerState$currentB = playerState.currentBuffer,
          currentBuffer = _playerState$currentB === void 0 ? 0 : _playerState$currentB,
          closedCaptions = playerState.closedCaptions,
          closedCaptionsActive = playerState.closedCaptionsActive;
      var currentTime = playerTimeState.currentTime,
          duration = playerTimeState.duration,
          isLive = playerTimeState.isLive,
          isAtLivePoint = playerTimeState.isAtLivePoint,
          seeking = playerTimeState.seeking,
          seekableRange = playerTimeState.seekableRange;
      var MIN_AD_HOC_DURATION = 60.0;
      var durationToUse = isLive ? seekableRange.end - seekableRange.start : duration;
      var hasClosedCaptions = !!(closedCaptions && closedCaptions.length);
      var isMinimumDuration = true; // VOD content can always seek
      // If live, we want to make sure the content is a minimum duration

      if (isLive) {
        isMinimumDuration = durationToUse >= MIN_AD_HOC_DURATION ? true : false;
      }

      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "default-controls-layout"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "top-controls-container"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_close_button, {
        mediaPlayer: mediaPlayer
      })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: this.getBottomControlsContainerClassNames()
      }, hasClosedCaptions ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_closed_captions, {
        mediaPlayer: mediaPlayer,
        closedCaptionsActive: closedCaptionsActive,
        closedCaptions: closedCaptions
      }) : null, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "seek-bar-container"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "duration-container"
      }, this.getTimeCodeDisplay(mediaPlayer, isLive, currentTime, durationToUse, seekableRange)), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "seek-bar"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_scrubber_bar, {
        mediaPlayer: mediaPlayer,
        startTime: seekableRange.start,
        endTime: seekableRange.end,
        duration: duration,
        currentTime: currentTime,
        seeking: seeking,
        buffer: currentBuffer,
        isLive: isLive,
        isMinimumDuration: isMinimumDuration,
        isAtLivePoint: isAtLivePoint
      }))), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: this.getBottomControlsClassNames()
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "bottom-controls-left"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_quick_rewind_button, {
        mediaPlayer: mediaPlayer,
        isEnabled: true,
        rewindValue: 15,
        duration: durationToUse,
        isMinimumDuration: isMinimumDuration,
        currentTime: currentTime
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(play_pause, {
        mediaPlayer: mediaPlayer,
        isPaused: paused,
        className: "media-control"
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_quick_forward_button, {
        mediaPlayer: mediaPlayer,
        isEnabled: true,
        forwardValue: 15,
        isMinimumDuration: isMinimumDuration,
        currentTime: currentTime
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(volume_mute_button, {
        mediaPlayer: mediaPlayer,
        volume: volume
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(volume_volume_slider, {
        mediaPlayer: mediaPlayer,
        volume: volume
      }), isLive ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_jump_to_live, {
        mediaPlayer: mediaPlayer,
        isLive: isLive,
        isAtLivePoint: isAtLivePoint,
        className: "media-control"
      }) : null), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "bottom-controls-right"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_closed_captions_button, {
        mediaPlayer: mediaPlayer,
        closedCaptionsActive: closedCaptionsActive,
        hasClosedCaptions: hasClosedCaptions
      }), isFullscreenEnabled ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_fullscreen_button, {
        mediaPlayer: mediaPlayer,
        isFullscreen: isFullscreen,
        fullscreenElement: fullscreenElement
      }) : null))));
    }
  }]);

  return DefaultLayout;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

default_layout_DefaultLayout.propTypes = {
  /** The MediaPlayer instance */
  mediaPlayer: prop_types_default.a.object,

  /** Should the controls be visible or not */
  controlsVisible: prop_types_default.a.bool,

  /** The element that will be toggled to fullscreen */
  fullscreenElement: prop_types_default.a.instanceOf(Element),

  /** Player state object from the playerState Subject event stream `data.stateModel` */
  playerState: prop_types_default.a.shape({
    paused: prop_types_default.a.bool,
    volume: prop_types_default.a.shape({
      value: prop_types_default.a.number,
      muted: prop_types_default.a.bool,
      lastValue: prop_types_default.a.number
    }),
    isFullscreen: prop_types_default.a.bool,
    isFullscreenEnabled: prop_types_default.a.bool,
    currentBuffer: prop_types_default.a.number,
    hasClosedCaptions: prop_types_default.a.bool,
    closedCaptionsActive: prop_types_default.a.bool
  }),
  playerTimeState: prop_types_default.a.shape({
    currentTime: prop_types_default.a.number,
    duration: prop_types_default.a.number,
    isLive: prop_types_default.a.bool,
    isAtLivePoint: prop_types_default.a.bool,
    seeking: prop_types_default.a.bool,
    seekableRange: prop_types_default.a.shape({
      start: prop_types_default.a.number,
      end: prop_types_default.a.number
    })
  })
};
default_layout_DefaultLayout.defaultProps = {
  mediaPlayer: undefined,
  controlsVisible: true,
  fullscreenElement: undefined,
  playerState: {
    paused: false,
    volume: {
      volume: 0,
      muted: false
    },
    isFullscreen: false,
    isFullscreenEnabled: false,
    currentBuffer: 0,
    hasClosedCaptions: false,
    closedCaptionsActive: false
  },
  playerTimeState: {
    currentTime: 0,
    duration: 0,
    isLive: false,
    isAtLivePoint: false,
    seeking: false,
    seekableRange: {
      start: 0,
      end: 0
    }
  }
};
/* harmony default export */ var default_layout_default_layout = (default_layout_DefaultLayout);
// CONCATENATED MODULE: ./src/js/layouts/default-layout/index.js


/* harmony default export */ var layouts_default_layout = (default_layout_default_layout);
// EXTERNAL MODULE: ./src/js/layouts/ad-layout/ad-layout.less
var ad_layout = __webpack_require__(120);

// EXTERNAL MODULE: ./src/js/controls/ad-play-pause/ad-play-pause.less
var ad_play_pause = __webpack_require__(122);

// CONCATENATED MODULE: ./src/js/controls/ad-play-pause/ad-play-pause.js
function ad_play_pause_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ad_play_pause_typeof = function _typeof(obj) { return typeof obj; }; } else { ad_play_pause_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ad_play_pause_typeof(obj); }

function ad_play_pause_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ad_play_pause_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ad_play_pause_createClass(Constructor, protoProps, staticProps) { if (protoProps) ad_play_pause_defineProperties(Constructor.prototype, protoProps); if (staticProps) ad_play_pause_defineProperties(Constructor, staticProps); return Constructor; }

function ad_play_pause_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ad_play_pause_setPrototypeOf(subClass, superClass); }

function ad_play_pause_setPrototypeOf(o, p) { ad_play_pause_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ad_play_pause_setPrototypeOf(o, p); }

function ad_play_pause_createSuper(Derived) { var hasNativeReflectConstruct = ad_play_pause_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ad_play_pause_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ad_play_pause_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ad_play_pause_possibleConstructorReturn(this, result); }; }

function ad_play_pause_possibleConstructorReturn(self, call) { if (call && (ad_play_pause_typeof(call) === "object" || typeof call === "function")) { return call; } return ad_play_pause_assertThisInitialized(self); }

function ad_play_pause_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ad_play_pause_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ad_play_pause_getPrototypeOf(o) { ad_play_pause_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ad_play_pause_getPrototypeOf(o); }

function ad_play_pause_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 *
 * Displays a play/pause toggle for ads.
 * ```js
 * <AdPlayPause mediaPlayer={this.props.mediaPlayer} />
 * ```
 *
 * @component AdPlayPause
 * @module AdPlayPause
 *
 */

var ad_play_pause_AdPlayPause = /*#__PURE__*/function (_Component) {
  ad_play_pause_inherits(AdPlayPause, _Component);

  var _super = ad_play_pause_createSuper(AdPlayPause);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function AdPlayPause(props) {
    var _this;

    ad_play_pause_classCallCheck(this, AdPlayPause);

    _this = _super.call(this, props);

    ad_play_pause_defineProperty(ad_play_pause_assertThisInitialized(_this), "onClick", function () {
      _this.setState({
        playing: !_this.state.playing
      });

      var pluginManager = _this.props.mediaPlayer.pluginManager;
      var advertisingPlugin = pluginManager && pluginManager.getPlugin('DfpPlugin');
      _this.state.playing ? advertisingPlugin.pause() : advertisingPlugin.resume();
    });

    _this.state = {
      playing: true
    };
    _this.subscriptions = [];
    return _this;
  }

  ad_play_pause_createClass(AdPlayPause, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
      this.subscriptions = [];
    }
  }, {
    key: "subscribe",
    value:
    /**
     *
     * Subscribes to pluginSubject for the `AdvertisingPluginEvents.AD_PAUSED` (`adPaused`) event stream
     * @private
     *
     */
    function subscribe() {
      var _this2 = this;

      var subscription = this.props.mediaPlayer.observationCenter.pluginSubject.pipe(Object(operators_["filter"])(function (_ref) {
        var type = _ref.type;
        return type === 'adPaused' || type === 'adResumed'; //AdvertisingPluginEvents.AD_PAUSED;
      })).subscribe(function (_ref2) {
        var type = _ref2.type;

        _this2.setState({
          playing: type === 'adResumed'
        });
      });
      this.subscriptions.push(subscription);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
    /**
     *
     * @desc Render the play/pause toggle
     *
     */

  }, {
    key: "render",
    value: function render() {
      var label = this.state.playing ? 'Pause' : 'Play';
      var ariaLabel = this.state.playing ? 'Pause (space)' : 'Play (space)';
      var className = this.state.playing ? 'media-control--ad-pause' : 'media-control--ad-play';
      var icon = this.state.playing ? /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(pause_icon, null) : /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(play_icon, null);
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_button_control, {
        onClick: this.onClick,
        label: label,
        ariaLabel: ariaLabel,
        className: className
      }, icon);
    }
  }]);

  return AdPlayPause;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

ad_play_pause_AdPlayPause.componentId = 'adPlayPause';
ad_play_pause_AdPlayPause.propTypes = {
  /** The MediaPlayer instance */
  mediaPlayer: prop_types_default.a.object
};
ad_play_pause_AdPlayPause.defaultProps = {
  mediaPlayer: undefined
};
/* harmony default export */ var ad_play_pause_ad_play_pause = (ad_play_pause_AdPlayPause);
// CONCATENATED MODULE: ./src/js/controls/ad-play-pause/index.js



/* harmony default export */ var controls_ad_play_pause = (with_config_hoc()(ad_play_pause_ad_play_pause));
// CONCATENATED MODULE: ./src/js/layouts/ad-layout/ad-layout.js
function ad_layout_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { ad_layout_typeof = function _typeof(obj) { return typeof obj; }; } else { ad_layout_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return ad_layout_typeof(obj); }

function ad_layout_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ad_layout_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function ad_layout_createClass(Constructor, protoProps, staticProps) { if (protoProps) ad_layout_defineProperties(Constructor.prototype, protoProps); if (staticProps) ad_layout_defineProperties(Constructor, staticProps); return Constructor; }

function ad_layout_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) ad_layout_setPrototypeOf(subClass, superClass); }

function ad_layout_setPrototypeOf(o, p) { ad_layout_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return ad_layout_setPrototypeOf(o, p); }

function ad_layout_createSuper(Derived) { var hasNativeReflectConstruct = ad_layout_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = ad_layout_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = ad_layout_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return ad_layout_possibleConstructorReturn(this, result); }; }

function ad_layout_possibleConstructorReturn(self, call) { if (call && (ad_layout_typeof(call) === "object" || typeof call === "function")) { return call; } return ad_layout_assertThisInitialized(self); }

function ad_layout_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function ad_layout_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ad_layout_getPrototypeOf(o) { ad_layout_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return ad_layout_getPrototypeOf(o); }







var ad_layout_AdLayout = /*#__PURE__*/function (_Component) {
  ad_layout_inherits(AdLayout, _Component);

  var _super = ad_layout_createSuper(AdLayout);

  function AdLayout(props) {
    ad_layout_classCallCheck(this, AdLayout);

    return _super.call(this, props);
  }

  ad_layout_createClass(AdLayout, [{
    key: "render",
    value: function render() {
      var volume = this.props.playerState.volume;
      var mediaPlayer = this.props.mediaPlayer;
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "ad-controls-layout"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "top-controls-container"
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "bottom-controls-container"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "seek-bar-container"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "duration-container"
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "seek-bar"
      })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "bottom-controls"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "bottom-controls-left"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_ad_play_pause, {
        mediaPlayer: mediaPlayer
      })), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "bottom-controls-right"
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(controls_ad_countdown, {
        mediaPlayer: mediaPlayer
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(volume_mute_button, {
        mediaPlayer: mediaPlayer,
        volume: volume
      })))));
    }
  }]);

  return AdLayout;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

ad_layout_AdLayout.propTypes = {
  /** The MediaPlayer instance */
  mediaPlayer: prop_types_default.a.object,

  /** Should the controls be visible or not */
  controlsVisible: prop_types_default.a.bool,

  /** The element that will be toggled to fullscreen */
  fullscreenElement: prop_types_default.a.instanceOf(Element),

  /** Player state object from the playerState Subject event stream `data.stateModel` */
  playerState: prop_types_default.a.shape({
    currentTime: prop_types_default.a.number,
    duration: prop_types_default.a.number,
    seekableRange: prop_types_default.a.shape({
      start: prop_types_default.a.number,
      end: prop_types_default.a.number
    }),
    paused: prop_types_default.a.bool,
    isLive: prop_types_default.a.bool,
    isAtLivePoint: prop_types_default.a.bool,
    volume: prop_types_default.a.shape({
      value: prop_types_default.a.number,
      muted: prop_types_default.a.bool,
      lastValue: prop_types_default.a.number
    }),
    isFullscreen: prop_types_default.a.bool,
    isFullscreenEnabled: prop_types_default.a.bool,
    seeking: prop_types_default.a.bool,
    currentBuffer: prop_types_default.a.number,
    hasClosedCaptions: prop_types_default.a.bool,
    closedCaptionsActive: prop_types_default.a.bool
  })
};
ad_layout_AdLayout.defaultProps = {
  mediaPlayer: undefined,
  controlsVisible: true,
  fullscreenElement: undefined,
  playerState: {
    currentTime: 0,
    duration: 0,
    seekableRange: {
      start: 0,
      end: 0
    },
    paused: false,
    isLive: false,
    isAtLivePoint: false,
    volume: {
      volume: 0,
      muted: false
    },
    isFullscreen: false,
    isFullscreenEnabled: false,
    seeking: false,
    currentBuffer: 0,
    hasClosedCaptions: false,
    closedCaptionsActive: false
  }
};
/* harmony default export */ var ad_layout_ad_layout = (ad_layout_AdLayout);
// CONCATENATED MODULE: ./src/js/layouts/ad-layout/index.js


/* harmony default export */ var layouts_ad_layout = (ad_layout_ad_layout);
// EXTERNAL MODULE: ./src/js/overlays/loading-spinner/loading-spinner.less
var loading_spinner = __webpack_require__(124);

// CONCATENATED MODULE: ./src/js/overlays/loading-spinner/loading-spinner.js
function loading_spinner_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { loading_spinner_typeof = function _typeof(obj) { return typeof obj; }; } else { loading_spinner_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return loading_spinner_typeof(obj); }

function loading_spinner_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function loading_spinner_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function loading_spinner_createClass(Constructor, protoProps, staticProps) { if (protoProps) loading_spinner_defineProperties(Constructor.prototype, protoProps); if (staticProps) loading_spinner_defineProperties(Constructor, staticProps); return Constructor; }

function loading_spinner_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) loading_spinner_setPrototypeOf(subClass, superClass); }

function loading_spinner_setPrototypeOf(o, p) { loading_spinner_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return loading_spinner_setPrototypeOf(o, p); }

function loading_spinner_createSuper(Derived) { var hasNativeReflectConstruct = loading_spinner_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = loading_spinner_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = loading_spinner_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return loading_spinner_possibleConstructorReturn(this, result); }; }

function loading_spinner_possibleConstructorReturn(self, call) { if (call && (loading_spinner_typeof(call) === "object" || typeof call === "function")) { return call; } return loading_spinner_assertThisInitialized(self); }

function loading_spinner_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function loading_spinner_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function loading_spinner_getPrototypeOf(o) { loading_spinner_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return loading_spinner_getPrototypeOf(o); }

/**
 *
 * @class LoadingSpinner
 * @desc Displays a play or pause button based on the playerState.paused value
 * @desc LoadingSpinner
 *
 */



var loading_spinner_LoadingSpinner = /*#__PURE__*/function (_Component) {
  loading_spinner_inherits(LoadingSpinner, _Component);

  var _super = loading_spinner_createSuper(LoadingSpinner);

  /**
   *
   * @param {object} props
   * @constructor
   *
   */
  function LoadingSpinner(props) {
    loading_spinner_classCallCheck(this, LoadingSpinner);

    return _super.call(this, props);
  }
  /**
   *
   * @desc Render the PlayButton or PauseButton based on the playerState.paused property
   *
   */


  loading_spinner_createClass(LoadingSpinner, [{
    key: "render",
    value: function render() {
      var visible = this.props.visible;
      var classes = classnames_default()({
        'mlb-player-controls-loader--container': true,
        'hidden': !visible
      });
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: classes
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "mlb-player-controls--loader"
      }));
    }
  }]);

  return LoadingSpinner;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

/* harmony default export */ var loading_spinner_loading_spinner = (loading_spinner_LoadingSpinner);
// CONCATENATED MODULE: ./src/js/overlays/loading-spinner/index.js


/* harmony default export */ var overlays_loading_spinner = (loading_spinner_loading_spinner);
// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM"}
var external_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_root_ReactDOM_ = __webpack_require__(29);
var external_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_root_ReactDOM_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_root_ReactDOM_);

// EXTERNAL MODULE: external {"root":["rxjs"],"commonjs":"rxjs","commonjs2":"rxjs","amd":"rxjs"}
var external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_ = __webpack_require__(10);

// EXTERNAL MODULE: /Users/peter.chou/Sites/MLB_AWS/web-media-playback/node_modules/lodash/includes.js
var includes = __webpack_require__(30);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// CONCATENATED MODULE: ./src/js/util/accessibility-util.js
function accessibility_util_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function accessibility_util_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function accessibility_util_createClass(Constructor, protoProps, staticProps) { if (protoProps) accessibility_util_defineProperties(Constructor.prototype, protoProps); if (staticProps) accessibility_util_defineProperties(Constructor, staticProps); return Constructor; }



/**
 *
 * @class AccessibilityUtil
 * @desc Utility object for enabling accessibility
 * @module AccessibilityUtil
 *
 */

var DEFAULT_KEYCODES = {
  TAB: 9,
  ENTER: 13,
  SPACE: 32,
  ESC: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  CTRL: 17,
  OPTION: 18,
  C: 67,
  F: 70,
  K: 75,
  M: 77
};
var SEEK_STEP = 15;
var VOLUME_STEP = .1;

var accessibility_util_AccessibilityUtil = /*#__PURE__*/function () {
  function AccessibilityUtil(props) {
    accessibility_util_classCallCheck(this, AccessibilityUtil);

    this.mediaPlayer = props.mediaPlayer;
    this.mediaConfig = this.mediaPlayer.config;
    this.fullscreenTargetNode = props.fullscreenTargetNode;
    this.focusData = props.focusData;
    this.playerState = {};
    this.playerTimeState = {
      currentTime: 0
    };
    /**
     *
     * @type {RXJS.BehaviorSubejct}
     *
     */

    this.controlsSubject = get_default()(this.mediaPlayer, 'observationCenter.controlsSubject');
    /**
     *
     * @type {DOMElement}
     *
     */

    this.styleElement = document.createElement('STYLE');
    document.getElementsByTagName('HEAD')[0].appendChild(this.styleElement);
    this.initializeEventListeners();
    this.subscribeToPlayerState();
    this.subscribeToPlayerTimeState();
  }
  /**
   *
   * @desc Sets the CSS on the provided element
   * @param {*} styleElement
   * @param {*} cssText
   *
   */


  accessibility_util_createClass(AccessibilityUtil, [{
    key: "setCss",
    value: function setCss(cssText) {
      this.styleElement.innerHTML = cssText;
    }
    /**
     *
     * @desc mouse down event handler. Clears the outline style set by keydown
     *
     */

  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      this.controlsSubject.next({
        type: AccessibilityUtil.TABBING_DISABLED
      });
      this.setCss('.media-player :focus{outline:0;} .media-player ::-moz-focus-inner{border:0;}');
    }
    /**
     *
     * @desc key down event handler. Clears the outline style set by keydown
     *
     */

  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      var keyCode = event.keyCode;

      if (includes_default()(DEFAULT_KEYCODES, keyCode)) {
        var controlsSubject = get_default()(this.mediaPlayer, 'observationCenter.controlsSubject');

        controlsSubject.next({
          type: AccessibilityUtil.TABBING_ENABLED
        });
        this.setCss(".media-player :focus{outline: 1px solid #3DB3F8 !important;}\n            .media-player ::-moz-focus-inner{outline: 1px solid #3DB3F8 !important;}");
      }
    }
  }, {
    key: "decodeKeystroke",
    value: function decodeKeystroke(key) {
      var customKeyCodes = get_default()(this.mediaConfig, 'config.playerTypeConfig.customKeyCodes', {});

      var ESC = get_default()(customKeyCodes, 'ESC', DEFAULT_KEYCODES.ESC);

      var SPACE = get_default()(customKeyCodes, 'SPACE', DEFAULT_KEYCODES.SPACE);

      var ARROW_LEFT = get_default()(customKeyCodes, 'ARROW_LEFT', DEFAULT_KEYCODES.ARROW_LEFT);

      var ARROW_UP = get_default()(customKeyCodes, 'ARROW_UP', DEFAULT_KEYCODES.ARROW_UP);

      var ARROW_RIGHT = get_default()(customKeyCodes, 'ARROW_RIGHT', DEFAULT_KEYCODES.ARROW_RIGHT);

      var ARROW_DOWN = get_default()(customKeyCodes, 'ARROW_DOWN', DEFAULT_KEYCODES.ARROW_DOWN);

      var C = get_default()(customKeyCodes, 'C', DEFAULT_KEYCODES.C);

      var F = get_default()(customKeyCodes, 'F', DEFAULT_KEYCODES.F);

      var K = get_default()(customKeyCodes, 'K', DEFAULT_KEYCODES.K);

      var M = get_default()(customKeyCodes, 'M', DEFAULT_KEYCODES.M);

      var command = null;
      var preventDefault = false;
      var _this$focusData = this.focusData,
          isButton = _this$focusData.isButton,
          focusedId = _this$focusData.focusedId;

      if (key === DEFAULT_KEYCODES.SPACE && isButton) {
        return {
          command: command,
          preventDefault: preventDefault
        };
      }

      switch (key) {
        case SPACE:
          {
            command = 'PLAY/PAUSE';
            preventDefault = true;
            break;
          }

        case M:
          {
            command = 'MUTE';
            break;
          }

        case F:
          {
            command = 'FULLSCREEN';
            break;
          }

        case ESC:
          {
            command = 'EXIT_FULLSCREEN';
            break;
          }

        case C:
          {
            command = 'CLOSED_CAPTIONS';
            break;
          }

        case ARROW_LEFT:
          {
            command = 'SEEK_BACKWARDS';
            preventDefault = true;

            if (focusedId === 'volumeSlider') {
              command = 'VOLUME_DOWN';
            }

            break;
          }

        case ARROW_RIGHT:
          {
            command = 'SEEK_FORWARD';
            preventDefault = true;

            if (focusedId === 'volumeSlider') {
              command = 'VOLUME_UP';
            }

            break;
          }

        case ARROW_UP:
          {
            command = 'VOLUME_UP';
            preventDefault = true;

            if (focusedId === 'scrubberBar') {
              command = 'SEEK_FORWARD';
            }

            break;
          }

        case ARROW_DOWN:
          {
            command = 'VOLUME_DOWN';
            preventDefault = true;

            if (focusedId === 'scrubberBar') {
              command = 'SEEK_BACKWARDS';
            }

            break;
          }
      }

      return {
        command: command,
        preventDefault: preventDefault
      };
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      var fullscreenTargetNode = this.fullscreenTargetNode,
          mediaPlayer = this.mediaPlayer,
          playerState = this.playerState,
          playerTimeState = this.playerTimeState,
          focusData = this.focusData;
      var volume = playerState.volume;
      var currentTime = playerTimeState.currentTime;

      var _this$decodeKeystroke = this.decodeKeystroke(event.keyCode),
          command = _this$decodeKeystroke.command,
          preventDefault = _this$decodeKeystroke.preventDefault;

      var playerId = mediaPlayer.getPlayerId(); // Do not continue without a mediaPlayer
      // or without focus

      if (!mediaPlayer || !focusData.focusedId || focusData.playerId !== playerId) {
        return;
      }

      switch (command) {
        case 'PLAY/PAUSE':
          {
            if (playerState.paused) {
              mediaPlayer.play();
            } else {
              mediaPlayer.pause();
            }

            break;
          }

        case 'MUTE':
          {
            if (playerState.volume.muted) {
              mediaPlayer.unMute();
            } else {
              mediaPlayer.mute();
            }

            break;
          }

        case 'FULLSCREEN':
          {
            if (playerState.isFullscreenEnabled) {
              if (playerState.isFullscreen) {
                mediaPlayer.exitFullscreen();
              } else {
                mediaPlayer.requestFullscreen(fullscreenTargetNode);
              }
            }

            break;
          }

        case 'EXIT_FULLSCREEN':
          {
            if (playerState.isFullscreenEnabled) {
              if (playerState.isFullscreen) {
                mediaPlayer.exitFullscreen();
              }
            }

            break;
          }

        case 'CLOSED_CAPTIONS':
          {
            if (playerState.closedCaptionsActive) {
              mediaPlayer.hideClosedCaptions();
            } else {
              mediaPlayer.showClosedCaptions();
            }

            break;
          }

        case 'SEEK_BACKWARDS':
          {
            mediaPlayer.seek(currentTime - SEEK_STEP);
            break;
          }

        case 'SEEK_FORWARD':
          {
            mediaPlayer.seek(currentTime + SEEK_STEP);
            break;
          }

        case 'VOLUME_UP':
          {
            if (volume.value < 1) {
              var increaseVolume = (volume.value + VOLUME_STEP).toFixed(1);
              mediaPlayer.setVolume(increaseVolume > 1 ? 1 : increaseVolume);
            }

            break;
          }

        case 'VOLUME_DOWN':
          {
            if (playerState.volume.value > 0) {
              var decreaseVolume = (volume.value - VOLUME_STEP).toFixed(1);
              mediaPlayer.setVolume(decreaseVolume < 0 ? 0 : decreaseVolume);
            }

            break;
          }
      }

      if (preventDefault) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: "initializeEventListeners",
    value: function initializeEventListeners() {
      /** Using mousedown instead of mouseover, so that previously focused elements don't lose
          focus ring on mouse move */
      document.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('keydown', this.handleKeyDown.bind(this));
      document.addEventListener('keyup', this.handleKeyUp.bind(this));
    }
  }, {
    key: "subscribeToPlayerState",
    value: function subscribeToPlayerState() {
      var _this = this;

      var stateSubject = this.mediaPlayer.observationCenter.stateSubject;
      var stateSubscription = stateSubject.subscribe(function (data) {
        if (data.type && data.type !== 'empty') {
          _this.playerState = data.stateModel;
        }

        ;
      });
    }
  }, {
    key: "subscribeToPlayerTimeState",
    value: function subscribeToPlayerTimeState() {
      var _this2 = this;

      var playerTimeSubject = this.mediaPlayer.observationCenter.playerTimeSubject;
      var playerTimeSubscription = playerTimeSubject.subscribe(function (data) {
        if (data.type && data.type !== 'empty') {
          _this2.playerTimeState = data.stateModel;
        }

        ;
      });
    }
  }]);

  return AccessibilityUtil;
}();

;
accessibility_util_AccessibilityUtil.TABBING_ENABLED = 'TABBING_ENABLED';
accessibility_util_AccessibilityUtil.TABBING_DISABLED = 'TABBING_DISABLED';
/* harmony default export */ var accessibility_util = (accessibility_util_AccessibilityUtil);
// EXTERNAL MODULE: ./src/js/layouts/media-controls.less
var media_controls = __webpack_require__(133);

// CONCATENATED MODULE: ./src/js/layouts/layout-manager.js
function layout_manager_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { layout_manager_typeof = function _typeof(obj) { return typeof obj; }; } else { layout_manager_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return layout_manager_typeof(obj); }

function layout_manager_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function layout_manager_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function layout_manager_createClass(Constructor, protoProps, staticProps) { if (protoProps) layout_manager_defineProperties(Constructor.prototype, protoProps); if (staticProps) layout_manager_defineProperties(Constructor, staticProps); return Constructor; }

function layout_manager_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) layout_manager_setPrototypeOf(subClass, superClass); }

function layout_manager_setPrototypeOf(o, p) { layout_manager_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return layout_manager_setPrototypeOf(o, p); }

function layout_manager_createSuper(Derived) { var hasNativeReflectConstruct = layout_manager_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = layout_manager_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = layout_manager_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return layout_manager_possibleConstructorReturn(this, result); }; }

function layout_manager_possibleConstructorReturn(self, call) { if (call && (layout_manager_typeof(call) === "object" || typeof call === "function")) { return call; } return layout_manager_assertThisInitialized(self); }

function layout_manager_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function layout_manager_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function layout_manager_getPrototypeOf(o) { layout_manager_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return layout_manager_getPrototypeOf(o); }












var layout_manager_LayoutManager = /*#__PURE__*/function (_Component) {
  layout_manager_inherits(LayoutManager, _Component);

  var _super = layout_manager_createSuper(LayoutManager);

  function LayoutManager(props) {
    var _this;

    layout_manager_classCallCheck(this, LayoutManager);

    _this = _super.call(this, props);
    _this.state = {
      controlsVisible: true
    };
    _this.ref = /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createRef();
    _this.timer = undefined;
    _this.tabbingEnabled = false;
    return _this;
  }

  layout_manager_createClass(LayoutManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startTimer();
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopTimer();
      this.unsubscribe();
    }
    /**
     *
     * @todo make timeout configurable
     *
     */

  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;

      var timeout = 8000;
      this.timer = setInterval(function () {
        _this2.hideControls();
      }, timeout);
    }
  }, {
    key: "stopTimer",
    value: function stopTimer() {
      clearInterval(this.timer);
    }
  }, {
    key: "resetTimer",
    value: function resetTimer() {
      this.stopTimer();
      this.startTimer();
    }
  }, {
    key: "showControls",
    value: function showControls() {
      this.setState({
        controlsVisible: true
      });
    }
  }, {
    key: "hideControls",
    value: function hideControls() {
      if (!this.tabbingEnabled) {
        this.setState({
          controlsVisible: false
        });
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this3 = this;

      var mouseEnterSub = Object(external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["fromEvent"])(this.ref.current, 'mouseenter').subscribe(function (event) {
        _this3.resetTimer();

        _this3.showControls();
      });
      var mouseLeaveSub = Object(external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["fromEvent"])(this.ref.current, 'mouseleave').subscribe(function (event) {
        _this3.stopTimer();

        _this3.hideControls();
      });
      var mouseMoveSub = Object(external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["fromEvent"])(this.ref.current, 'mousemove').pipe(Object(operators_["throttleTime"])(Object(external_root_rxjs_commonjs_rxjs_commonjs2_rxjs_amd_rxjs_["interval"])(1000))).subscribe(function (event) {
        _this3.resetTimer();

        if (!_this3.state.controlsVisible) {
          _this3.showControls();
        }
      });
      var controlsSub = this.props.mediaPlayer.observationCenter.controlsSubject.subscribe(function (event) {
        if (event.type !== 'empty') {
          switch (event.type) {
            case accessibility_util.TABBING_ENABLED:
              {
                _this3.tabbingEnabled = true;

                _this3.showControls();

                _this3.stopTimer();

                break;
              }

            case accessibility_util.TABBING_DISABLED:
              {
                _this3.tabbingEnabled = false;

                _this3.resetTimer();

                break;
              }
          }
        }
      });
      this.subscriptions = [mouseEnterSub, mouseLeaveSub, mouseMoveSub, controlsSub];
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
    /**
     *
     * @desc Remove default controls from mediaPlayer
     *
     */

  }, {
    key: "removeDefaultControls",
    value: function removeDefaultControls() {
      if (this.props.mediaPlayer.player.videoEl) {
        this.props.mediaPlayer.removeDefaultControls();
      }
    }
  }, {
    key: "getLayout",
    value: function getLayout() {
      var _this$props = this.props,
          playerState = _this$props.playerState,
          playerTimeState = _this$props.playerTimeState,
          isMobile = _this$props.isMobile,
          mediaPlayer = _this$props.mediaPlayer,
          fullscreenElement = _this$props.fullscreenElement;
      var controlsVisible = this.state.controlsVisible;

      if (playerState.isAdPlaying && get_default()(mediaPlayer, 'config.controlsConfig.showAdControls', true)) {
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(layouts_ad_layout, {
          mediaPlayer: mediaPlayer,
          playerState: playerState,
          playerTimeState: playerTimeState,
          fullscreenElement: fullscreenElement,
          controlsVisible: controlsVisible
        });
      }

      if (!playerState.isAdPlaying && !isMobile && get_default()(mediaPlayer, 'config.controlsConfig.showDesktopControls', true)) {
        return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(layouts_default_layout, {
          mediaPlayer: mediaPlayer,
          playerState: playerState,
          playerTimeState: playerTimeState,
          fullscreenElement: fullscreenElement,
          controlsVisible: controlsVisible
        });
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          playerState = _this$props2.playerState,
          isMobile = _this$props2.isMobile;
      var isAdPlaying = playerState.isAdPlaying;
      var showMediaControls = true;

      if (isMobile) {
        if (!isAdPlaying) {
          showMediaControls = false;
        }
      } else {
        this.removeDefaultControls();
      }

      var classes = classnames_default()({
        'media-controls': showMediaControls,
        'media-controls-no-pointer-events': isAdPlaying
      });
      return /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: classes,
        ref: this.ref
      }, this.getLayout());
    }
  }]);

  return LayoutManager;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

layout_manager_LayoutManager.propTypes = {
  /** The MediaPlayer instance */
  mediaPlayer: prop_types_default.a.object,

  /** Should the controls be visible or not */
  controlsVisible: prop_types_default.a.bool,

  /** The element that will be toggled to fullscreen */
  fullscreenElement: prop_types_default.a.instanceOf(Element),

  /** Player state object from the playerState Subject event stream `data.stateModel` */
  playerState: prop_types_default.a.shape({
    paused: prop_types_default.a.bool,
    volume: prop_types_default.a.shape({
      value: prop_types_default.a.number,
      muted: prop_types_default.a.bool,
      lastValue: prop_types_default.a.number
    }),
    isFullscreen: prop_types_default.a.bool,
    isFullscreenEnabled: prop_types_default.a.bool,
    currentBuffer: prop_types_default.a.number,
    hasClosedCaptions: prop_types_default.a.bool,
    closedCaptionsActive: prop_types_default.a.bool
  }),
  playerTimeState: prop_types_default.a.shape({
    currentTime: prop_types_default.a.number,
    duration: prop_types_default.a.number,
    isLive: prop_types_default.a.bool,
    isAtLivePoint: prop_types_default.a.bool,
    seeking: prop_types_default.a.bool,
    seekableRange: prop_types_default.a.shape({
      start: prop_types_default.a.number,
      end: prop_types_default.a.number
    })
  }),
  isMobile: prop_types_default.a.bool
};
layout_manager_LayoutManager.defaultProps = {
  mediaPlayer: undefined,
  controlsVisible: true,
  fullscreenElement: undefined,
  playerState: {
    paused: false,
    volume: {
      volume: 0,
      muted: false
    },
    isFullscreen: false,
    isFullscreenEnabled: false,
    currentBuffer: 0,
    hasClosedCaptions: false,
    closedCaptionsActive: false
  },
  playerTimeState: {
    currentTime: 0,
    duration: 0,
    isLive: false,
    isAtLivePoint: false,
    seeking: false,
    seekableRange: {
      start: 0,
      end: 0
    }
  },
  isMobile: false
};
/* harmony default export */ var layout_manager = (layout_manager_LayoutManager);
// CONCATENATED MODULE: ./src/js/player-controls-component.js
function player_controls_component_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { player_controls_component_typeof = function _typeof(obj) { return typeof obj; }; } else { player_controls_component_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return player_controls_component_typeof(obj); }

function player_controls_component_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function player_controls_component_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function player_controls_component_createClass(Constructor, protoProps, staticProps) { if (protoProps) player_controls_component_defineProperties(Constructor.prototype, protoProps); if (staticProps) player_controls_component_defineProperties(Constructor, staticProps); return Constructor; }

function player_controls_component_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) player_controls_component_setPrototypeOf(subClass, superClass); }

function player_controls_component_setPrototypeOf(o, p) { player_controls_component_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return player_controls_component_setPrototypeOf(o, p); }

function player_controls_component_createSuper(Derived) { var hasNativeReflectConstruct = player_controls_component_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = player_controls_component_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = player_controls_component_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return player_controls_component_possibleConstructorReturn(this, result); }; }

function player_controls_component_possibleConstructorReturn(self, call) { if (call && (player_controls_component_typeof(call) === "object" || typeof call === "function")) { return call; } return player_controls_component_assertThisInitialized(self); }

function player_controls_component_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function player_controls_component_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function player_controls_component_getPrototypeOf(o) { player_controls_component_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return player_controls_component_getPrototypeOf(o); }

function player_controls_component_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 * @class PlayerControls
 * @desc The player controls container
 * @module PlayerControls
 *
 */








var player_controls_component_PlayerControls = /*#__PURE__*/function (_Component) {
  player_controls_component_inherits(PlayerControls, _Component);

  var _super = player_controls_component_createSuper(PlayerControls);

  /**
   *
   * @constructor
   * @param {object} props
   *
   */
  function PlayerControls(props) {
    var _this;

    player_controls_component_classCallCheck(this, PlayerControls);

    _this = _super.call(this, props);

    player_controls_component_defineProperty(player_controls_component_assertThisInitialized(_this), "_onBlur", function () {
      _this.props.focus.managedFocus(false);

      _this.props.focus.focusLost();
    });

    player_controls_component_defineProperty(player_controls_component_assertThisInitialized(_this), "_onFocus", function () {
      _this.props.focus.managedFocus(true);
    });

    _this.accessibilityUtil;
    _this.subscriptions = [];
    _this._isMounted = false;
    _this.state = {
      showControls: true,
      playerState: {
        playing: false,
        paused: true,
        stopped: true,
        mediaStarted: false,
        volume: {
          value: 0,
          muted: false,
          lastVolume: 70
        },
        seeking: false,
        isFullscreenEnabled: true,
        isFullscreen: false,
        isAdPlaying: false,
        isAudioOnly: false,
        selectedAudioTrack: undefined,
        selectedBitRate: 1
      },
      playerTimeState: {
        seekableRange: {
          start: 0,
          end: 0
        },
        isLive: false,
        currentTime: 0,
        duration: 0,
        bufferedValue: 0
      }
    };
    return _this;
  }

  player_controls_component_createClass(PlayerControls, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
      this.subscribe();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = true;
      this.subscriptions.forEach(function (subscription) {
        subscription.unsubscribe();
      });
    }
  }, {
    key: "createAccessibilityUtil",
    value: function createAccessibilityUtil(mediaPlayer, fullscreenTargetNode, focusData) {
      if (mediaPlayer && fullscreenTargetNode && !this.accessibilityUtil) {
        this.accessibilityUtil = new accessibility_util({
          mediaPlayer: mediaPlayer,
          fullscreenTargetNode: fullscreenTargetNode,
          focusData: focusData
        });
      }
    }
    /**
     *
     * @desc Subscribe to the player state subject
     *
     */

  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      var mediaPlayer = this.props.mediaPlayer;
      var observationCenter = mediaPlayer.observationCenter;
      var playerTimeSubject = observationCenter.playerTimeSubject,
          stateSubject = observationCenter.stateSubject,
          controlsSubject = observationCenter.controlsSubject;
      var playerTimeSubscription = playerTimeSubject.pipe(Object(operators_["throttleTime"])(300)).subscribe(function (data) {
        if (_this2._isMounted & (data.type && data.type !== 'empty')) {
          _this2.setState({
            playerTimeState: data.stateModel
          });
        }

        ;
      });
      this.subscriptions.push(playerTimeSubscription);
      var stateSubscription = stateSubject.subscribe(function (data) {
        if (data.type && data.type !== 'empty') {
          _this2.setState({
            playerState: data.stateModel
          });
        }

        ;
      });
      this.subscriptions.push(stateSubscription);
      var controlsSubscription = controlsSubject.subscribe(function (data) {
        switch (data.type) {
          case 'SHOW_CONTROLS':
            _this2.setState({
              showControls: true
            });

            break;

          case 'HIDE_CONTROLS':
            _this2.setState({
              showControls: false
            });

            break;
        }

        ;
      });
      this.subscriptions.push(controlsSubscription);
    }
  }, {
    key: "render",
    value:
    /**
     *
     * @desc render the LayoutManager control
     *
     */
    function render() {
      var _this$props = this.props,
          deviceInfo = _this$props.deviceInfo,
          playerWrapper = _this$props.playerWrapper,
          fullscreenElementId = _this$props.fullscreenElementId,
          mediaPlayer = _this$props.mediaPlayer;
      var _this$state = this.state,
          playerState = _this$state.playerState,
          playerTimeState = _this$state.playerTimeState,
          showControls = _this$state.showControls;
      var parentEl = mediaPlayer.player.parentEl;
      var targetNode = playerWrapper ? playerWrapper : parentEl;
      var fullscreenTargetNode = document.getElementById(fullscreenElementId);
      var isLoaderVisible = playerState.loading;
      var isMobile = false;

      if (deviceInfo && deviceInfo.formFactor) {
        isMobile = ['phone', 'tablet'].indexOf(deviceInfo.formFactor) > -1;
      }

      this.createAccessibilityUtil(mediaPlayer, fullscreenTargetNode, this.props.focus);
      return targetNode && showControls ? /*#__PURE__*/external_commonjs_react_dom_commonjs2_react_dom_amd_react_dom_root_ReactDOM_default.a.createPortal( /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement("div", {
        className: "mlb-player-controls",
        onBlur: this._onBlur,
        onFocus: this._onFocus
      }, /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(layout_manager, {
        isMobile: isMobile,
        mediaPlayer: mediaPlayer,
        fullscreenElement: fullscreenTargetNode,
        playerState: playerState,
        playerTimeState: playerTimeState
      }), /*#__PURE__*/external_commonjs_react_commonjs2_react_amd_react_root_React_default.a.createElement(overlays_loading_spinner, {
        visible: isLoaderVisible
      })), targetNode) : null;
    }
  }]);

  return PlayerControls;
}(external_commonjs_react_commonjs2_react_amd_react_root_React_["Component"]);

player_controls_component_PlayerControls.propTypes = {
  deviceInfo: prop_types_default.a.object,

  /** The MediaPlayer instance */
  mediaPlayer: prop_types_default.a.object,

  /** The id of the DOM Element that will be toggled to and from fullscreen */
  fullscreenElementId: prop_types_default.a.string
};
player_controls_component_PlayerControls.defaultProps = {
  deviceInfo: {},
  mediaPlayer: undefined,
  fullscreenElementId: 'media-app-container'
};
/* harmony default export */ var player_controls_component = (player_controls_component_PlayerControls);
// CONCATENATED MODULE: ./src/js/player-controls.js


/* harmony default export */ var player_controls = (focusConsumer(player_controls_component));
// CONCATENATED MODULE: ./src/js/entry.js
// Controls












 // Control Events

 // Layouts


 // Overlays

 // Base controls



/***/ })
/******/ ]);
});
//# sourceMappingURL=player-controls.js.map